import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, vModelText as _vModelText, vShow as _vShow, withModifiers as _withModifiers, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withKeys as _withKeys, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = { class: "header-icon" }
const _hoisted_3 = { class: "header-text" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "modal-tabs" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "auto-notice" }
const _hoisted_10 = { class: "form-section" }
const _hoisted_11 = { class: "gubun-tabs" }
const _hoisted_12 = {
  key: 0,
  class: "form-group"
}
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "form-row two-cols compact" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 1,
  class: "form-group insert-position-group"
}
const _hoisted_19 = { class: "form-label" }
const _hoisted_20 = { class: "existing-count" }
const _hoisted_21 = { class: "insert-position-options" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "option-order" }
const _hoisted_24 = { class: "option-memo" }
const _hoisted_25 = { class: "option-price" }
const _hoisted_26 = {
  key: 2,
  class: "form-group"
}
const _hoisted_27 = { class: "loading-existing" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = {
  key: 3,
  class: "form-group"
}
const _hoisted_30 = { class: "modal-body excel-body" }
const _hoisted_31 = { class: "excel-upload-section" }
const _hoisted_32 = {
  key: 0,
  class: "no-bank-warning"
}
const _hoisted_33 = { class: "quick-upload-mode" }
const _hoisted_34 = { class: "quick-upload-guide" }
const _hoisted_35 = { class: "bank-file-list" }
const _hoisted_36 = { class: "bank-info-col" }
const _hoisted_37 = { class: "bank-details" }
const _hoisted_38 = { class: "bank-alias" }
const _hoisted_39 = { class: "bank-name" }
const _hoisted_40 = { class: "file-col" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onChange"]
const _hoisted_43 = { class: "file-name" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "quick-upload-actions" }
const _hoisted_46 = { class: "upload-summary" }
const _hoisted_47 = {
  key: 0,
  class: "no-files"
}
const _hoisted_48 = {
  key: 1,
  class: "has-files"
}
const _hoisted_49 = ["disabled"]
const _hoisted_50 = { class: "quick-confirm-header" }
const _hoisted_51 = { class: "confirm-title" }
const _hoisted_52 = { class: "quick-confirm-guide" }
const _hoisted_53 = { class: "quick-file-analyses" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { class: "card-left" }
const _hoisted_56 = { class: "card-info" }
const _hoisted_57 = { class: "card-bank" }
const _hoisted_58 = { class: "card-file" }
const _hoisted_59 = { class: "card-right" }
const _hoisted_60 = {
  key: 0,
  class: "mapping-summary"
}
const _hoisted_61 = {
  key: 1,
  class: "error-badge"
}
const _hoisted_62 = {
  key: 0,
  class: "analysis-card-body"
}
const _hoisted_63 = {
  key: 0,
  class: "header-selection-step"
}
const _hoisted_64 = { class: "excel-preview-wrapper" }
const _hoisted_65 = { class: "excel-preview-table" }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { class: "col-select" }
const _hoisted_68 = { class: "select-indicator" }
const _hoisted_69 = { class: "col-rownum" }
const _hoisted_70 = { class: "step-actions" }
const _hoisted_71 = ["disabled", "onClick"]
const _hoisted_72 = {
  key: 1,
  class: "memo-selection-step"
}
const _hoisted_73 = { class: "step-title" }
const _hoisted_74 = ["onClick"]
const _hoisted_75 = { class: "mapping-info" }
const _hoisted_76 = { class: "mapping-value" }
const _hoisted_77 = { class: "mapping-value" }
const _hoisted_78 = { class: "mapping-value" }
const _hoisted_79 = { class: "mapping-item role-balance" }
const _hoisted_80 = { class: "mapping-value" }
const _hoisted_81 = { class: "memo-column-select" }
const _hoisted_82 = { class: "memo-select-label" }
const _hoisted_83 = { class: "memo-columns" }
const _hoisted_84 = ["checked", "disabled", "onChange"]
const _hoisted_85 = { class: "col-name" }
const _hoisted_86 = { class: "sample-preview" }
const _hoisted_87 = { class: "preview-table-wrapper" }
const _hoisted_88 = { class: "preview-table role-colored" }
const _hoisted_89 = { class: "th-name" }
const _hoisted_90 = {
  key: 0,
  class: "th-role"
}
const _hoisted_91 = { class: "quick-upload-actions" }
const _hoisted_92 = { class: "upload-summary" }
const _hoisted_93 = {
  key: 0,
  class: "no-files"
}
const _hoisted_94 = {
  key: 1,
  class: "has-files"
}
const _hoisted_95 = {
  key: 0,
  class: "invalid-count"
}
const _hoisted_96 = ["disabled"]
const _hoisted_97 = { class: "result-header" }
const _hoisted_98 = { class: "result-text" }
const _hoisted_99 = {
  key: 0,
  class: "learning-upload-mode"
}
const _hoisted_100 = { class: "learning-upload-guide" }
const _hoisted_101 = { class: "upload-row" }
const _hoisted_102 = { class: "bank-select-inline" }
const _hoisted_103 = { class: "inline-label" }
const _hoisted_104 = ["value"]
const _hoisted_105 = {
  key: 0,
  class: "upload-bank-hint"
}
const _hoisted_106 = { class: "file-select-inline" }
const _hoisted_107 = { class: "inline-label" }
const _hoisted_108 = {
  key: 0,
  class: "placeholder"
}
const _hoisted_109 = { class: "file-name" }
const _hoisted_110 = { class: "file-size" }
const _hoisted_111 = {
  key: 1,
  class: "analyze-buttons"
}
const _hoisted_112 = {
  key: 2,
  class: "header-selection-section"
}
const _hoisted_113 = {
  key: 0,
  class: "sheet-selection"
}
const _hoisted_114 = ["value"]
const _hoisted_115 = { class: "header-selection-header" }
const _hoisted_116 = { class: "header-preview-table" }
const _hoisted_117 = { class: "preview-table header-select-mode" }
const _hoisted_118 = ["onClick"]
const _hoisted_119 = { class: "td-row-num" }
const _hoisted_120 = { class: "header-selection-actions" }
const _hoisted_121 = ["disabled"]
const _hoisted_122 = {
  key: 3,
  class: "memo-selection-section"
}
const _hoisted_123 = { class: "memo-selection-header" }
const _hoisted_124 = ["disabled"]
const _hoisted_125 = { class: "memo-column-list" }
const _hoisted_126 = ["checked", "onChange"]
const _hoisted_127 = { class: "column-index" }
const _hoisted_128 = { class: "column-name" }
const _hoisted_129 = {
  key: 0,
  class: "cell-override-hint"
}
const _hoisted_130 = { class: "memo-preview-table" }
const _hoisted_131 = { class: "preview-header" }
const _hoisted_132 = { class: "preview-table-wrapper" }
const _hoisted_133 = { class: "preview-table cell-select-mode" }
const _hoisted_134 = ["onClick"]
const _hoisted_135 = { class: "td-row-num" }
const _hoisted_136 = ["onClick"]
const _hoisted_137 = { class: "td-memo-result" }
const _hoisted_138 = { class: "memo-selection-actions" }
const _hoisted_139 = ["disabled"]
const _hoisted_140 = {
  key: 4,
  class: "process-status"
}
const _hoisted_141 = { class: "process-header" }
const _hoisted_142 = {
  key: 0,
  class: "process-progress"
}
const _hoisted_143 = { class: "progress-bar" }
const _hoisted_144 = {
  key: 1,
  class: "process-result compact"
}
const _hoisted_145 = { class: "result-row" }
const _hoisted_146 = { class: "result-item income" }
const _hoisted_147 = { class: "amount" }
const _hoisted_148 = { class: "result-item expense" }
const _hoisted_149 = { class: "amount" }
const _hoisted_150 = {
  key: 0,
  class: "learning-fullscreen"
}
const _hoisted_151 = { class: "learning-toolbar" }
const _hoisted_152 = { class: "toolbar-left" }
const _hoisted_153 = { class: "file-badge" }
const _hoisted_154 = { class: "toolbar-right" }
const _hoisted_155 = { class: "progress-badge" }
const _hoisted_156 = { class: "done" }
const _hoisted_157 = { class: "total" }
const _hoisted_158 = { class: "learning-content" }
const _hoisted_159 = { class: "groups-panel" }
const _hoisted_160 = { class: "panel-header" }
const _hoisted_161 = { class: "header-controls" }
const _hoisted_162 = { class: "sort-controls" }
const _hoisted_163 = ["title"]
const _hoisted_164 = { class: "filter-tabs" }
const _hoisted_165 = { class: "search-section" }
const _hoisted_166 = { class: "search-input-wrapper" }
const _hoisted_167 = {
  key: 0,
  class: "search-result-actions"
}
const _hoisted_168 = { class: "search-result-info" }
const _hoisted_169 = ["disabled"]
const _hoisted_170 = { class: "multi-select-toolbar" }
const _hoisted_171 = { class: "multi-select-toggle" }
const _hoisted_172 = {
  key: 0,
  class: "selected-count"
}
const _hoisted_173 = ["disabled"]
const _hoisted_174 = { class: "groups-list" }
const _hoisted_175 = ["onClick"]
const _hoisted_176 = ["checked", "onChange"]
const _hoisted_177 = { class: "card-content" }
const _hoisted_178 = { class: "card-top" }
const _hoisted_179 = {
  key: 0,
  class: "date-badge"
}
const _hoisted_180 = { class: "count-badge" }
const _hoisted_181 = { class: "total-badge" }
const _hoisted_182 = { class: "card-keyword" }
const _hoisted_183 = { class: "card-bottom" }
const _hoisted_184 = { class: "scode-name" }
const _hoisted_185 = {
  key: 1,
  class: "unlearned-hint"
}
const _hoisted_186 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_187 = { class: "bulk-assign-modal" }
const _hoisted_188 = { class: "bulk-modal-header" }
const _hoisted_189 = { class: "header-text" }
const _hoisted_190 = { class: "bulk-modal-body" }
const _hoisted_191 = { class: "bulk-preview" }
const _hoisted_192 = { class: "preview-header" }
const _hoisted_193 = { class: "count" }
const _hoisted_194 = { class: "preview-list" }
const _hoisted_195 = { class: "gubun-badge" }
const _hoisted_196 = { class: "keyword" }
const _hoisted_197 = { class: "count" }
const _hoisted_198 = {
  key: 0,
  class: "preview-more"
}
const _hoisted_199 = { class: "bulk-gubun-select" }
const _hoisted_200 = { class: "gubun-options" }
const _hoisted_201 = { class: "bulk-account-select" }
const _hoisted_202 = { class: "bulk-keyword-option" }
const _hoisted_203 = { class: "checkbox-label" }
const _hoisted_204 = { class: "option-hint" }
const _hoisted_205 = { class: "bulk-modal-footer" }
const _hoisted_206 = ["disabled"]
const _hoisted_207 = { class: "bulk-assign-modal" }
const _hoisted_208 = { class: "bulk-modal-header" }
const _hoisted_209 = { class: "header-text" }
const _hoisted_210 = { class: "bulk-modal-body" }
const _hoisted_211 = { class: "bulk-preview" }
const _hoisted_212 = { class: "preview-header" }
const _hoisted_213 = { class: "count" }
const _hoisted_214 = { class: "preview-list" }
const _hoisted_215 = { class: "gubun-badge" }
const _hoisted_216 = { class: "keyword" }
const _hoisted_217 = {
  key: 0,
  class: "preview-more"
}
const _hoisted_218 = { class: "bulk-gubun-select" }
const _hoisted_219 = { class: "gubun-options" }
const _hoisted_220 = { class: "bulk-account-select" }
const _hoisted_221 = { class: "bulk-modal-footer" }
const _hoisted_222 = ["disabled"]
const _hoisted_223 = { class: "detail-panel" }
const _hoisted_224 = { class: "detail-header" }
const _hoisted_225 = { class: "keyword-display" }
const _hoisted_226 = { class: "detail-stats" }
const _hoisted_227 = { class: "account-select-section" }
const _hoisted_228 = {
  key: 0,
  class: "learned-source"
}
const _hoisted_229 = { class: "matching-memos" }
const _hoisted_230 = { class: "memos-header" }
const _hoisted_231 = { class: "memos-list" }
const _hoisted_232 = {
  key: 0,
  class: "memo-date"
}
const _hoisted_233 = { class: "memo-text" }
const _hoisted_234 = { class: "memo-price" }
const _hoisted_235 = {
  key: 0,
  class: "registered-keywords-section"
}
const _hoisted_236 = { class: "section-header" }
const _hoisted_237 = { class: "registered-list" }
const _hoisted_238 = { class: "rk-keyword" }
const _hoisted_239 = { class: "rk-account" }
const _hoisted_240 = ["onClick"]
const _hoisted_241 = {
  key: 1,
  class: "empty-detail"
}
const _hoisted_242 = { class: "learning-footer" }
const _hoisted_243 = { class: "footer-info" }
const _hoisted_244 = { class: "footer-actions" }
const _hoisted_245 = ["disabled"]
const _hoisted_246 = { class: "confirm-dialog" }
const _hoisted_247 = { class: "confirm-dialog__header" }
const _hoisted_248 = ["disabled"]
const _hoisted_249 = { class: "confirm-content" }
const _hoisted_250 = { key: 0 }
const _hoisted_251 = { key: 1 }
const _hoisted_252 = {
  key: 0,
  class: "confirm-summary"
}
const _hoisted_253 = { class: "summary-item" }
const _hoisted_254 = {
  key: 0,
  class: "summary-item"
}
const _hoisted_255 = { class: "summary-item" }
const _hoisted_256 = { class: "confirm-actions" }
const _hoisted_257 = {
  key: 1,
  class: "modal-footer"
}
const _hoisted_258 = ["disabled"]
const _hoisted_259 = { key: 1 }
const _hoisted_260 = { class: "help-dialog" }
const _hoisted_261 = { class: "help-header" }
const _hoisted_262 = { class: "help-content" }
const _hoisted_263 = { class: "help-section" }
const _hoisted_264 = { class: "section-title" }
const _hoisted_265 = { class: "help-footer" }
const _hoisted_266 = { class: "save-snackbar-content" }

import { ref, computed, watch, nextTick } from 'vue';
import YmdDateInput from '@/components/common/YmdDateInput.vue';
import { bankbookApi } from '@/services/api';

// ============================================
// Props & Emits
// ============================================

interface AccountCode {
  scode: string;
  sname: string;
  gubun: 'IN' | 'OUT';
}

interface BankData {
  mb_idx: number;
  m_code: number;
  mb_code: string;
  mb_alias: string;
  mb_bank_name: string;
  mb_account_no: string;
  mb_purpose?: string;
  mb_sort_order: number;
  mb_is_active: number;
  mb_start_date?: string | null;
  mb_end_date?: string | null;
  mb_biz_gubun?: string | null;
}

interface MemoGroup {
  keyword: string;
  gubun: 'IN' | 'OUT';
  memos: Array<{ memo: string; gubun: string; price: number; date?: string }>;
  totalPrice: number;
  count: number;
  latestDate?: string;
  learned?: {
    scode: string;
    scode_name?: string;
    count: number;
    source: 'facility' | 'otherFacility' | 'allBizGubun';
  };
  selectedScode?: string;
  isEditing?: boolean;
  customKeywords?: string[];
}

interface UploadResultInfo {
  bankCode: string;
  bankAlias: string;
  fileName: string;
  count: number;
  success: boolean;
  message?: string;
}

interface ExistingItem {
  cb_idx: number;
  cb_order: number;
  cb_memo: string;
  cb_gubun: string;
  cb_price: number;
}
interface QuickFileAnalysis {
  bankCode: string;
  bankAlias: string;
  file: File;
  headers: string[];
  headerRowIndex: number;
  sampleData: string[][];
  columnMapping: {
    date?: number;
    income?: number;
    expense?: number;
    amount?: number;
    balance?: number;
    memo?: number | number[];
  };
  isValid: boolean;
  errorMessage?: string;
  // 사용자 수정 가능
  selectedMemoColumns: number[];
  // 2단계 UI용
  step: 'header' | 'memo';
  previewRows: string[][];
  suggestedHeaderRowIndex: number | null;
  selectedHeaderRowIndex: number | null;
  detectionConfidence: 'high' | 'medium' | 'low';  // 헤더 감지 신뢰도
}
interface UploadFileItem {
  file: File;
  bankCode: string;
  status: 'pending' | 'processing' | 'done' | 'error';
  resultCount?: number;
  errorMessage?: string;
}
interface RegisteredKeyword {
  gubun: 'IN' | 'OUT';
  keyword: string;
  scode: string;
  scodeName: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'PgmBankbookUpload',
  props: {
    modelValue: { type: Boolean },
    memberCode: {},
    currentYear: {},
    currentMonth: {},
    bizGubun: {},
    incomeCodeList: {},
    expenseCodeList: {},
    bankList: {},
    selectedBankCode: {}
  },
  emits: ["update:modelValue", "saved", "uploadComplete"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// 업로드 결과 타입
const emit = __emit;

// ============================================
// 상태
// ============================================

const dialogOpen = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

const activeTab = ref<'input' | 'excel'>('excel');
const currentStep = ref<'upload' | 'learning'>('upload');
const formRef = ref<any>(null);
const fileInputRef = ref<HTMLInputElement | null>(null);

// 직접 입력 폼
const formData = ref({
  gubun: 'OUT' as 'IN' | 'OUT',
  inout_date: '',
  price: 0,
  memo: '',
  relAcc: '',
  bankCode: ''
});
const priceFocused = ref(false);
const isPredicting = ref(false);
const isSaving = ref(false);
const prediction = ref<any>(null);
const predictionError = ref('');

// 삽입 위치 관련
const existingItemsForDate = ref<ExistingItem[]>([]);
const isLoadingExistingItems = ref(false);
const insertPosition = ref<'first' | 'last' | number>('last');  // 'first', 'last', 또는 cb_idx (해당 항목 뒤에 삽입)

// 엑셀 업로드
const excelFile = ref<File | null>(null);
const isDragOver = ref(false);
const isProcessing = ref(false);
const processComplete = ref(false);
const processStatus = ref<{
  message: string;
  current?: number;
  total?: number;
}>({ message: '' });

// 업로드 모드
const uploadMode = ref<'quick' | 'learning'>('quick');

// 빠른 업로드 관련
const quickUploadFiles = ref<Record<string, File>>({});
const quickFileInputRefs = ref<Record<string, HTMLInputElement | null>>({});
const isQuickUploading = ref(false);
const quickUploadComplete = ref(false);
const quickUploadResult = ref({ totalCount: 0, successCount: 0, errorCount: 0 });

// 빠른 업로드 헤더 확인 단계
const quickUploadStep = ref<'select' | 'confirm' | 'uploading'>('select');
const quickFileAnalyses = ref<QuickFileAnalysis[]>([]);
const isAnalyzingFiles = ref(false);
const currentAnalysisIndex = ref(0);

// 다중 파일 업로드 관련
const uploadFileList = ref<UploadFileItem[]>([]);
const multiFileInputRef = ref<HTMLInputElement | null>(null);

const processResult = ref({
  incomeCount: 0,
  incomeTotal: 0,
  expenseCount: 0,
  expenseTotal: 0,
  totalCount: 0
});

// 헤더 행 선택
const needHeaderSelection = ref(false);
const headerPreviewData = ref<string[][] | null>(null);
const selectedHeaderRowIndex = ref<number | null>(null);
const isLoadingPreview = ref(false);

// 시트 선택
const sheetNames = ref<string[]>([]);
const selectedSheetIndex = ref(0);

// 적요 컬럼 선택
const needMemoSelection = ref(false);
const memoSelectionData = ref<{
  headers: { index: number; name: string }[];
  sampleData: string[][];
  headerRowIndex: number;
  columnMapping: any;
  autoMemoIndex?: number;
} | null>(null);
const selectedMemoColumns = ref<number[]>([]);
const selectedMemoCells = ref<Record<number, Record<number, boolean>>>({});

// 학습 단계
const showLearning = ref(false);
const learningScope = ref<'facility' | 'bizGubun' | 'all'>('facility');
const memoGroups = ref<MemoGroup[]>([]);
const isLoadingGroups = ref(false);
const selectedGroupIdx = ref<number | null>(null);
const groupFilter = ref<'all' | 'learned' | 'unlearned'>('all');
// 정렬 관련
const groupSortField = ref<'date' | 'amount'>('date');
const groupSortOrder = ref<'asc' | 'desc'>('desc');
// 검색 관련
const groupSearchQuery = ref('');
const showBulkAssignModal = ref(false);
const bulkAssignGubun = ref<'all' | 'IN' | 'OUT'>('all');
const bulkAssignScode = ref<string | null>(null);
const bulkRegisterAsKeyword = ref(true);
// 다중 선택 관련
const selectedGroupIndices = ref<Set<number>>(new Set());
const isMultiSelectMode = ref(false);
const showBulkAssignSelectedModal = ref(false);
const bulkSelectedGubun = ref<'all' | 'IN' | 'OUT'>('all');
const bulkSelectedScode = ref<string | null>(null);

// 확인 다이얼로그
const confirmDialogOpen = ref(false);
const confirmDialogType = ref<'skip' | 'saveAndRegister'>('skip');

// 직접 등록한 키워드 목록
const registeredKeywords = ref<RegisteredKeyword[]>([]);

// 도움말
const showHelpDialog = ref(false);

// 저장 완료 스낵바
const showSaveSnackbar = ref(false);
const saveSnackbarMessage = ref('');

// 통장 선택 (업로드 모달 전용 — 사이드바 선택과 분리)
const selectedUploadBankCode = ref<string | null>(null);
const uploadBankUserTouched = ref(false);

const selectedUploadBankLabel = computed(() => {
  if (!selectedUploadBankCode.value) return '';
  const bank = activeBankList.value.find(b => b.mb_code === selectedUploadBankCode.value);
  return bank ? `${bank.mb_alias} (${bank.mb_bank_name})` : selectedUploadBankCode.value;
});

const appendUploadCommonFields = (formDataObj: FormData) => {
  formDataObj.append('year', props.currentYear);
  formDataObj.append('month', props.currentMonth);
  if (props.bizGubun) formDataObj.append('bizGubun', props.bizGubun);
};

const appendRequiredBankCode = (formDataObj: FormData, bankCode: string | null | undefined, context = '업로드') => {
  const code = String(bankCode || '').trim();
  if (!code) {
    throw new Error(`${context}: 통장을 선택해주세요.`);
  }
  formDataObj.append('bankCode', code);
  return code;
};

const onUploadBankSelectChange = () => {
  uploadBankUserTouched.value = true;
};

// ============================================
// Computed
// ============================================

const getHeaderTitle = computed(() => {
  return activeTab.value === 'input' ? '항목 추가' : '통장내역 업로드';
});

const getHeaderSubtitle = computed(() => {
  return activeTab.value === 'input'
    ? '통장·일자·금액·적요를 직접 입력합니다'
    : '통장별 엑셀 파일을 올려 내역을 등록합니다';
});

const formattedPrice = computed(() => {
  return formData.value.price ? formData.value.price.toLocaleString('ko-KR') : '';
});

const canPredict = computed(() => {
  return formData.value.memo.trim().length > 0 && formData.value.price > 0;
});

const canSave = computed(() => {
  const hasBank = activeBankList.value.length === 0 || formData.value.bankCode;
  return formData.value.inout_date && formData.value.price > 0 && formData.value.memo.trim() && hasBank;
});

// 날짜 변경 시 해당 날짜의 기존 내역 조회
const loadExistingItemsForDate = async () => {
  const date = formData.value.inout_date;
  const bankCode = formData.value.bankCode;
  
  if (!date || !props.memberCode) {
    existingItemsForDate.value = [];
    insertPosition.value = 'last';
    return;
  }
  
  isLoadingExistingItems.value = true;
  try {
    // 해당 날짜의 통장내역 조회 (startDate, endDate 동일하게 설정)
    const res = await bankbookApi.getList(
      props.memberCode, 
      date.substring(0, 4),  // year
      date.substring(5, 7),  // month
      props.bizGubun || undefined,
      bankCode || undefined
    );
    
    if (res.data?.data) {
      // 해당 날짜의 항목만 필터링하고 cb_order 순으로 정렬
      const items = res.data.data
        .filter((item: any) => item.cb_date === date)
        .sort((a: any, b: any) => (Number(a.cb_order) || 0) - (Number(b.cb_order) || 0))
        .map((item: any) => ({
          cb_idx: item.cb_idx,
          cb_order: Number(item.cb_order) || 0,
          cb_memo: item.cb_memo || '',
          cb_gubun: item.cb_gubun,
          cb_price: item.cb_price
        }));
      existingItemsForDate.value = items;
    } else {
      existingItemsForDate.value = [];
    }
  } catch (error) {
    console.error('기존 내역 조회 오류:', error);
    existingItemsForDate.value = [];
  } finally {
    isLoadingExistingItems.value = false;
    insertPosition.value = 'last';  // 기본값: 맨 뒤
  }
};

// 날짜 또는 통장 변경 시 기존 내역 조회
watch(() => [formData.value.inout_date, formData.value.bankCode], () => {
  loadExistingItemsForDate();
}, { immediate: false });

const canConfirmMemoSelection = computed(() => {
  return selectedMemoColumns.value.length > 0;
});

// 업로드 가능 여부 (통장이 있고 선택된 경우, 또는 통장 목록이 비어있는 경우)
const canUpload = computed(() => {
  if (!props.bankList || props.bankList.length === 0) return false;
  return !!selectedUploadBankCode.value;
});

// 통장이 선택 연월에 사용 가능한지 (MemberDetailBankbook.isBankActiveForCurrentMonth 와 동일)
const isBankActiveForMonth = (bank: BankData): boolean => {
  const year = String(props.currentYear);
  const month = String(props.currentMonth).padStart(2, '0');
  const currentYM = `${year}-${month}`;

  if (!bank.mb_start_date) return true;
  if (currentYM < bank.mb_start_date) return false;
  if (bank.mb_end_date && currentYM > bank.mb_end_date) return false;
  return true;
};

// 업로드 가능 통장: 사용기간 + 활성(mb_is_active=1) — 삭제(비활성) 통장 제외
const activeBankList = computed(() => {
  return (props.bankList || []).filter(
    (b) => isBankActiveForMonth(b) && b.mb_is_active === 1
  );
});

// 빠른 업로드 파일 개수
const quickUploadFileCount = computed(() => {
  return Object.keys(quickUploadFiles.value).length;
});

// 유효한 분석 파일 수
const validAnalysesCount = computed(() => {
  return quickFileAnalyses.value.filter(a => a.isValid).length;
});

// 유효하지 않은 분석 파일 수
const invalidAnalysesCount = computed(() => {
  return quickFileAnalyses.value.filter(a => !a.isValid).length;
});

// 다중 파일 업로드 가능 여부
const canMultiUpload = computed(() => {
  if (uploadFileList.value.length === 0) return false;
  // 모든 파일에 통장이 선택되어 있어야 함
  return uploadFileList.value.every(item => item.bankCode && item.status === 'pending');
});

// 업로드 진행 중인지
const isMultiUploading = computed(() => {
  return uploadFileList.value.some(item => item.status === 'processing');
});

// 모든 파일 업로드 완료 여부
const allFilesUploaded = computed(() => {
  return uploadFileList.value.length > 0 && uploadFileList.value.every(item => item.status === 'done' || item.status === 'error');
});

const learnedGroupCount = computed(() => {
  return memoGroups.value.filter(g => g.learned || g.selectedScode).length;
});

const incomeCodeList = computed(() => props.incomeCodeList || []);
const expenseCodeList = computed(() => props.expenseCodeList || []);

const filteredGroups = computed(() => {
  if (groupFilter.value === 'all') return memoGroups.value;
  if (groupFilter.value === 'learned') {
    return memoGroups.value.filter(g => g.learned || g.selectedScode);
  }
  return memoGroups.value.filter(g => !g.learned && !g.selectedScode);
});

// 검색 결과 그룹
const searchResultGroups = computed(() => {
  if (!groupSearchQuery.value.trim()) return [];
  const query = groupSearchQuery.value.toLowerCase().trim();
  return memoGroups.value.filter(g => {
    // 키워드에 검색어 포함
    if (g.keyword.toLowerCase().includes(query)) return true;
    // 포함된 적요 중 하나라도 검색어 포함
    return g.memos.some(m => m.memo.toLowerCase().includes(query));
  });
});

// 실제 표시되는 그룹 (필터 + 검색 + 정렬 적용)
const displayedGroups = computed(() => {
  let groups = [...filteredGroups.value];
  
  // 검색어가 있으면 검색 결과만 표시
  if (groupSearchQuery.value.trim()) {
    const query = groupSearchQuery.value.toLowerCase().trim();
    groups = groups.filter(g => {
      if (g.keyword.toLowerCase().includes(query)) return true;
      return g.memos.some(m => m.memo.toLowerCase().includes(query));
    });
  }
  
  // 정렬 적용
  groups.sort((a, b) => {
    let comparison = 0;
    
    if (groupSortField.value === 'date') {
      // 날짜순: latestDate 기준 (없으면 맨 뒤로)
      const dateA = a.latestDate || '';
      const dateB = b.latestDate || '';
      comparison = dateA.localeCompare(dateB);
    } else if (groupSortField.value === 'amount') {
      // 금액순: totalPrice 기준
      comparison = a.totalPrice - b.totalPrice;
    }
    
    // 정렬 순서 (오름차순/내림차순)
    return groupSortOrder.value === 'asc' ? comparison : -comparison;
  });
  
  return groups;
});

// 빈 상태 메시지
const getEmptyStateMessage = computed(() => {
  if (groupSearchQuery.value.trim()) {
    return `"${groupSearchQuery.value}" 검색 결과가 없습니다.`;
  }
  if (groupFilter.value === 'unlearned') {
    return '모든 적요가 학습되었습니다!';
  }
  return '표시할 항목이 없습니다.';
});

// 일괄 적용 대상 개수
const getBulkApplyCount = computed(() => {
  if (bulkAssignGubun.value === 'all') return searchResultGroups.value.length;
  return searchResultGroups.value.filter(g => g.gubun === bulkAssignGubun.value).length;
});

// 다중 선택된 그룹 목록
const selectedGroupsForBulk = computed(() => {
  return Array.from(selectedGroupIndices.value)
    .map(idx => memoGroups.value[idx])
    .filter(Boolean);
});

// 다중 선택 일괄 적용 대상 개수
const getBulkSelectedApplyCount = computed(() => {
  if (bulkSelectedGubun.value === 'all') return selectedGroupsForBulk.value.length;
  return selectedGroupsForBulk.value.filter(g => g.gubun === bulkSelectedGubun.value).length;
});

// 현재 표시된 그룹이 모두 선택되었는지 확인
const isAllDisplayedSelected = computed(() => {
  if (displayedGroups.value.length === 0) return false;
  return displayedGroups.value.every(group => 
    selectedGroupIndices.value.has(getOriginalIndex(group))
  );
});

// 총 적요 건수
const getTotalMemoCount = computed(() => {
  return memoGroups.value.reduce((sum, g) => sum + g.memos.length, 0);
});

const selectedGroup = computed(() => {
  if (selectedGroupIdx.value === null) return null;
  return memoGroups.value[selectedGroupIdx.value];
});

// 선택된 그룹의 적요 목록 (날짜순 정렬)
const sortedSelectedMemos = computed(() => {
  if (!selectedGroup.value) return [];
  return [...selectedGroup.value.memos].sort((a, b) => {
    // 날짜가 있으면 날짜순, 없으면 원래 순서
    if (a.date && b.date) {
      return a.date.localeCompare(b.date);
    }
    if (a.date) return -1;
    if (b.date) return 1;
    return 0;
  });
});

// ============================================
// 메서드
// ============================================

const formatNumber = (value: number): string => {
  return value.toLocaleString('ko-KR');
};

const formatMemoDate = (dateStr: string): string => {
  if (!dateStr) return '';
  // 다양한 날짜 형식 처리
  const cleaned = String(dateStr).trim();
  // YYYY-MM-DD 또는 YYYY/MM/DD 형식
  const match = cleaned.match(/(\d{4})[-/]?(\d{1,2})[-/]?(\d{1,2})/);
  if (match) {
    const month = match[2].padStart(2, '0');
    const day = match[3].padStart(2, '0');
    return `${month}/${day}`;
  }
  return cleaned;
};

const getGroupDateDisplay = (group: MemoGroup): string => {
  // 1. latestDate가 있으면 사용
  if (group.latestDate) {
    return formatMemoDate(group.latestDate);
  }
  // 2. memos에서 날짜 찾기
  if (group.memos && group.memos.length > 0) {
    const datesInMemos = group.memos
      .map(m => m.date)
      .filter(d => d)
      .sort((a, b) => (b || '').localeCompare(a || '')); // 최신순
    if (datesInMemos.length > 0) {
      return formatMemoDate(datesInMemos[0] || '');
    }
  }
  return '';
};

const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};

const getConfidenceClass = (confidence: number): string => {
  if (confidence >= 0.8) return 'high';
  if (confidence >= 0.5) return 'medium';
  return 'low';
};

const getSourceName = (source: string): string => {
  switch (source) {
    case 'keyword': return '키워드 매칭';
    case 'similar': return '유사 거래';
    case 'stats': return '통계 기반';
    case 'rule': return '규칙 기반';
    default: return source || '알 수 없음';
  }
};

const formatBankAccountNo = (accountNo: string): string => {
  if (!accountNo) return '';
  if (accountNo.length <= 8) return accountNo;
  const front = accountNo.slice(0, 4);
  const back = accountNo.slice(-4);
  return `${front}****${back}`;
};

// ============================================
// 다중 파일 업로드 관련 메서드
// ============================================

const triggerMultiFileInput = () => {
  multiFileInputRef.value?.click();
};

const handleMultiFileSelect = (e: Event) => {
  const target = e.target as HTMLInputElement;
  if (target.files && target.files.length > 0) {
    addFilesToList(Array.from(target.files));
    target.value = ''; // 같은 파일 다시 선택 가능하도록
  }
};

const handleMultiDrop = (e: DragEvent) => {
  isDragOver.value = false;
  if (e.dataTransfer?.files && e.dataTransfer.files.length > 0) {
    const files = Array.from(e.dataTransfer.files).filter(f => 
      f.name.endsWith('.xlsx') || f.name.endsWith('.xls') || f.name.endsWith('.csv')
    );
    if (files.length > 0) {
      addFilesToList(files);
    }
  }
};

const addFilesToList = (files: File[]) => {
  for (const file of files) {
    // 중복 파일 체크
    const exists = uploadFileList.value.some(item => item.file.name === file.name && item.file.size === file.size);
    if (!exists) {
      // 선택된 통장이 있으면 기본값으로 설정
      const defaultBankCode = props.selectedBankCode || (activeBankList.value.length === 1 ? activeBankList.value[0].mb_code : '');
      uploadFileList.value.push({
        file,
        bankCode: defaultBankCode,
        status: 'pending'
      });
    }
  }
};

const removeFileFromList = (index: number) => {
  uploadFileList.value.splice(index, 1);
};

const clearAllFiles = () => {
  uploadFileList.value = [];
};

// 다중 파일 일괄 업로드
const processMultiUpload = async () => {
  if (!canMultiUpload.value) return;
  
  isProcessing.value = true;
  processComplete.value = false;
  
  let totalIncomeCount = 0;
  let totalExpenseCount = 0;
  let successCount = 0;
  let errorCount = 0;
  
  for (let i = 0; i < uploadFileList.value.length; i++) {
    const item = uploadFileList.value[i];
    if (item.status !== 'pending') continue;
    
    item.status = 'processing';
    processStatus.value = { message: `${item.file.name} 처리 중...`, current: i + 1, total: uploadFileList.value.length };
    
    try {
      const formDataObj = new FormData();
      formDataObj.append('file', item.file);
      formDataObj.append('year', props.currentYear);
      formDataObj.append('month', props.currentMonth);
      if (props.bizGubun) formDataObj.append('bizGubun', props.bizGubun);
      appendRequiredBankCode(formDataObj, item.bankCode, item.file.name);
      // 다중 파일 업로드는 자동 매핑된 적요 컬럼 사용 (학습 데이터 기반 계정 추론)
      formDataObj.append('skipMemoSelection', 'true');
      
      const res = await bankbookApi.uploadExcel(props.memberCode, formDataObj);
      
      if (res.data?.success && !res.data?.needMemoSelection) {
        const result = res.data.data || res.data;
        item.status = 'done';
        item.resultCount = (result.incomeCount || 0) + (result.expenseCount || 0);
        totalIncomeCount += result.incomeCount || 0;
        totalExpenseCount += result.expenseCount || 0;
        successCount++;
      } else if (res.data?.needMemoSelection) {
        // 적요 컬럼 선택이 필요한 경우 (다중 업로드에서는 자동 매핑 사용하므로 이 경우는 발생하지 않아야 함)
        item.status = 'error';
        item.errorMessage = '파일 형식 분석 필요 - 단일 업로드 사용';
        errorCount++;
      } else {
        item.status = 'error';
        item.errorMessage = res.data?.message || '업로드 실패';
        errorCount++;
      }
    } catch (error: any) {
      item.status = 'error';
      item.errorMessage = error.response?.data?.message || '업로드 오류';
      errorCount++;
    }
  }
  
  processComplete.value = true;
  processResult.value = {
    incomeCount: totalIncomeCount,
    incomeTotal: 0,
    expenseCount: totalExpenseCount,
    expenseTotal: 0,
    totalCount: totalIncomeCount + totalExpenseCount
  };
  processStatus.value = { 
    message: `완료: ${successCount}개 파일 성공${errorCount > 0 ? `, ${errorCount}개 실패` : ''}` 
  };
  isProcessing.value = false;
  
  if (successCount > 0) {
    emit('saved', []);
  }
};

const handlePriceInput = (e: Event) => {
  const input = e.target as HTMLInputElement;
  const value = input.value.replace(/[^0-9]/g, '');
  formData.value.price = parseInt(value) || 0;
};

const handlePriceKeydown = (e: KeyboardEvent) => {
  if (e.key === 'Enter') {
    predictFields();
  }
};

const predictFields = async () => {
  if (!canPredict.value || isPredicting.value) return;
  
  isPredicting.value = true;
  prediction.value = null;
  predictionError.value = '';
  
  try {
    const res = await bankbookApi.infer(props.memberCode, {
      gubun: formData.value.gubun,
      memo: formData.value.memo,
      bizGubun: props.bizGubun,
      scope: 'all',
      year: props.currentYear
    });
    
    if (res.data?.data) {
      prediction.value = res.data.data;
    } else {
      predictionError.value = '학습된 데이터가 없습니다.';
    }
  } catch (error: any) {
    console.error('AI 추론 오류:', error);
    predictionError.value = error.response?.data?.message || 'AI 추론에 실패했습니다.';
  } finally {
    isPredicting.value = false;
  }
};

const saveManualInput = async () => {
  if (!canSave.value || isSaving.value) return;
  
  isSaving.value = true;
  try {
    let res;
    
    const baseData = {
      m_code: String(props.memberCode || ''),
      cb_biz_gubun: props.bizGubun,
      cb_bank_code: formData.value.bankCode || undefined,
      cb_gubun: formData.value.gubun as 'IN' | 'OUT',
      cb_date: formData.value.inout_date,
      cb_price: formData.value.price,
      cb_memo: formData.value.memo,
      cb_scode: undefined,
      cb_rel_acc: formData.value.gubun === 'OUT' ? (formData.value.relAcc || undefined) : undefined,
      cb_source: 'manual'
    };
    
    // 삽입 위치에 따라 다른 API 호출
    if (insertPosition.value === 'last' || existingItemsForDate.value.length === 0) {
      // 맨 뒤에 추가 (기본 create API)
      res = await bankbookApi.create(baseData);
    } else if (insertPosition.value === 'first') {
      // 맨 앞에 삽입 (첫 번째 항목 앞에)
      const firstItem = existingItemsForDate.value[0];
      res = await bankbookApi.insertAt({
        targetCbIdx: firstItem.cb_idx,
        position: 'before',
        ...baseData
      });
    } else {
      // 특정 항목 뒤에 삽입
      res = await bankbookApi.insertAt({
        targetCbIdx: insertPosition.value as number,
        position: 'after',
        ...baseData
      });
    }
    
    if (res.data?.data) {
      emit('saved', [res.data.data]);
      closeDialog();
    }
  } catch (error: any) {
    console.error('저장 오류:', error);
    const message = error.response?.data?.message || '저장에 실패했습니다.';
    alert(message);
  } finally {
    isSaving.value = false;
  }
};

const triggerFileInput = () => {
  fileInputRef.value?.click();
};

// ========== 빠른 업로드 관련 함수 ==========
const switchUploadMode = (mode: 'quick' | 'learning') => {
  if (uploadMode.value === mode) return;
  
  // 모드 전환 시 상태 초기화
  uploadMode.value = mode;
  
  if (mode === 'quick') {
    // 학습 모드 상태 초기화
    excelFile.value = null;
    resetAnalysisState();
  } else {
    // 빠른 업로드 상태 초기화
    quickUploadFiles.value = {};
    quickUploadComplete.value = false;
    quickUploadResult.value = { totalCount: 0, successCount: 0, errorCount: 0 };
  }
};

const setQuickFileInputRef = (el: any, bankCode: string) => {
  if (el && el instanceof HTMLInputElement) {
    quickFileInputRefs.value[bankCode] = el;
  }
};

const triggerQuickFileInput = (bankCode: string) => {
  const input = quickFileInputRefs.value[bankCode];
  if (input) {
    input.click();
  }
};

const handleQuickFileSelect = (e: Event, bankCode: string) => {
  const input = e.target as HTMLInputElement;
  if (input.files && input.files[0]) {
    quickUploadFiles.value = {
      ...quickUploadFiles.value,
      [bankCode]: input.files[0]
    };
  }
  // input 초기화 (같은 파일 재선택 가능하도록)
  input.value = '';
};

const removeQuickFile = (bankCode: string) => {
  const newFiles = { ...quickUploadFiles.value };
  delete newFiles[bankCode];
  quickUploadFiles.value = newFiles;
};

const resetQuickUpload = () => {
  quickUploadFiles.value = {};
  quickUploadComplete.value = false;
  quickUploadResult.value = { totalCount: 0, successCount: 0, errorCount: 0 };
  quickUploadStep.value = 'select';
  quickFileAnalyses.value = [];
  currentAnalysisIndex.value = 0;
};

// 파일 분석 (헤더 확인 단계)
const analyzeQuickUploadFiles = async () => {
  if (quickUploadFileCount.value === 0) return;
  
  isAnalyzingFiles.value = true;
  quickFileAnalyses.value = [];
  
  try {
    const entries = Object.entries(quickUploadFiles.value);
    
    for (const [bankCode, file] of entries) {
      const bankInfo = activeBankList.value.find(b => b.mb_code === bankCode);
      
      try {
        // 파일 분석 API 호출
        const formData = new FormData();
        formData.append('file', file);
        
        const response = await bankbookApi.analyzeExcel(props.memberCode, formData);
        
        if (response.data.success && response.data.data) {
          const data = response.data.data;
          const mapping = data.columnMapping || {};
          
          // 적요 컬럼 기본 선택
          let selectedMemoColumns: number[] = [];
          if (mapping.memo !== undefined) {
            selectedMemoColumns = Array.isArray(mapping.memo) ? mapping.memo : [mapping.memo];
          }
          
          // 유효성 검사: 날짜와 금액(입금/출금 또는 금액) 컬럼 필요
          const hasDate = mapping.date !== undefined;
          const hasAmount = mapping.income !== undefined || mapping.expense !== undefined || mapping.amount !== undefined;
          const isValid = hasDate && hasAmount;
          
          quickFileAnalyses.value.push({
            bankCode,
            bankAlias: bankInfo?.mb_alias || bankCode,
            file,
            headers: data.headers || [],
            headerRowIndex: data.headerRowIndex || 0,
            sampleData: data.sampleData || [],
            columnMapping: mapping,
            isValid,
            errorMessage: !isValid ? (hasDate ? '금액 컬럼 미감지' : '날짜 컬럼 미감지') : undefined,
            selectedMemoColumns,
            // 2단계 UI용
            step: 'header',
            previewRows: data.previewRows || [],
            suggestedHeaderRowIndex: data.suggestedHeaderRowIndex,
            selectedHeaderRowIndex: data.suggestedHeaderRowIndex,
            detectionConfidence: data.detectionConfidence || 'low'
          });
        } else {
          // 분석 실패
          quickFileAnalyses.value.push({
            bankCode,
            bankAlias: bankInfo?.mb_alias || bankCode,
            file,
            headers: [],
            headerRowIndex: 0,
            sampleData: [],
            columnMapping: {},
            isValid: false,
            errorMessage: response.data.message || '파일 분석 실패',
            selectedMemoColumns: [],
            step: 'header',
            previewRows: [],
            suggestedHeaderRowIndex: null,
            selectedHeaderRowIndex: null,
            detectionConfidence: 'low'
          });
        }
      } catch (err: any) {
        quickFileAnalyses.value.push({
          bankCode,
          bankAlias: bankInfo?.mb_alias || bankCode,
          file,
          headers: [],
          headerRowIndex: 0,
          sampleData: [],
          columnMapping: {},
          isValid: false,
          errorMessage: err.message || '파일 분석 오류',
          selectedMemoColumns: [],
          step: 'header',
          previewRows: [],
          suggestedHeaderRowIndex: null,
          selectedHeaderRowIndex: null,
          detectionConfidence: 'low'
        });
      }
    }
    
    // 첫 번째 유효하지 않은 파일 또는 첫 번째 파일 펼치기
    const firstInvalidIdx = quickFileAnalyses.value.findIndex(a => !a.isValid);
    currentAnalysisIndex.value = firstInvalidIdx >= 0 ? firstInvalidIdx : 0;
    
    // 헤더 확인 단계로 이동
    quickUploadStep.value = 'confirm';
    
  } finally {
    isAnalyzingFiles.value = false;
  }
};

// 분석 카드 펼치기/접기
const toggleAnalysisCard = (idx: number) => {
  currentAnalysisIndex.value = currentAnalysisIndex.value === idx ? -1 : idx;
};

// 예약된 컬럼인지 확인 (날짜, 금액 등은 적요로 선택 불가)
const isReservedColumn = (analysis: QuickFileAnalysis, colIdx: number): boolean => {
  const m = analysis.columnMapping;
  return colIdx === m.date || 
         colIdx === m.income || 
         colIdx === m.expense || 
         colIdx === m.amount || 
         colIdx === m.balance;
};

/** 샘플표 열 역할 클래스 (색 = 의미) */
const quickSampleColClass = (analysis: QuickFileAnalysis, colIdx: number) => {
  const m = analysis.columnMapping;
  if (analysis.selectedMemoColumns.includes(colIdx)) return 'col-memo';
  if (colIdx === m.date) return 'col-date';
  if (colIdx === m.income) return 'col-income';
  if (colIdx === m.expense) return 'col-expense';
  if (colIdx === m.amount) return 'col-amount';
  if (colIdx === m.balance) return 'col-balance';
  return 'col-plain';
};

const quickSampleRoleLabel = (analysis: QuickFileAnalysis, colIdx: number): string => {
  const m = analysis.columnMapping;
  if (analysis.selectedMemoColumns.includes(colIdx)) return '적요';
  if (colIdx === m.date) return '날짜';
  if (colIdx === m.income) return '입금';
  if (colIdx === m.expense) return '출금';
  if (colIdx === m.amount) return '금액';
  if (colIdx === m.balance) return '잔액';
  return '';
};

// 엑셀 컬럼 이름 생성 (A, B, C, ... Z, AA, AB, ...)
const getExcelColumnName = (index: number): string => {
  let name = '';
  let idx = index;
  while (idx >= 0) {
    name = String.fromCharCode((idx % 26) + 65) + name;
    idx = Math.floor(idx / 26) - 1;
  }
  return name;
};

// 미리보기 행들 중 최대 컬럼 수 계산 (최대 12개로 제한)
const getMaxColumns = (rows: string[][]): number => {
  if (!rows || rows.length === 0) return 0;
  const maxCols = Math.max(...rows.map(row => row.length));
  return Math.min(maxCols, 12);
};

// 헤더 행 선택
const selectHeaderRow = (analysisIdx: number, rowIdx: number) => {
  const analysis = quickFileAnalyses.value[analysisIdx];
  if (!analysis) return;
  
  analysis.selectedHeaderRowIndex = rowIdx;
};

// 헤더 행 확정 후 적요 선택 단계로 이동
const confirmHeaderRow = async (analysisIdx: number) => {
  const analysis = quickFileAnalyses.value[analysisIdx];
  if (!analysis || analysis.selectedHeaderRowIndex === null) return;
  
  // 선택된 헤더 행으로 컬럼 매핑 다시 분석
  const headerRow = analysis.previewRows[analysis.selectedHeaderRowIndex];
  if (!headerRow) return;
  
  // 서버에 다시 분석 요청 (선택된 헤더 행으로)
  try {
    const formData = new FormData();
    formData.append('file', analysis.file);
    formData.append('headerRowIndex', String(analysis.selectedHeaderRowIndex));
    
    const response = await bankbookApi.analyzeExcel(props.memberCode, formData);
    
    if (response.data.success && response.data.data) {
      const data = response.data.data;
      const mapping = data.columnMapping || {};
      
      // 업데이트
      analysis.headers = data.headers || [];
      analysis.headerRowIndex = analysis.selectedHeaderRowIndex;
      analysis.sampleData = data.sampleData || [];
      analysis.columnMapping = mapping;
      
      // 적요 컬럼 기본 선택
      if (mapping.memo !== undefined) {
        analysis.selectedMemoColumns = Array.isArray(mapping.memo) ? mapping.memo : [mapping.memo];
      } else {
        analysis.selectedMemoColumns = [];
      }
      
      // 유효성 검사
      const hasDate = mapping.date !== undefined;
      const hasAmount = mapping.income !== undefined || mapping.expense !== undefined || mapping.amount !== undefined;
      analysis.isValid = hasDate && hasAmount;
      analysis.errorMessage = !analysis.isValid ? (hasDate ? '금액 컬럼 미감지' : '날짜 컬럼 미감지') : undefined;
    }
  } catch (err) {
    console.error('헤더 재분석 오류:', err);
  }
  
  // 적요 선택 단계로 이동
  analysis.step = 'memo';
};

// 적요 컬럼 토글
const toggleQuickMemoColumn = (analysisIdx: number, colIdx: number) => {
  const analysis = quickFileAnalyses.value[analysisIdx];
  if (!analysis) return;
  
  const idx = analysis.selectedMemoColumns.indexOf(colIdx);
  if (idx >= 0) {
    analysis.selectedMemoColumns.splice(idx, 1);
  } else {
    analysis.selectedMemoColumns.push(colIdx);
  }
};

// 매핑 정보 포함하여 업로드
const processQuickUploadWithMapping = async () => {
  const validAnalyses = quickFileAnalyses.value.filter(a => a.isValid);
  if (validAnalyses.length === 0) return;
  
  isQuickUploading.value = true;
  let totalCount = 0;
  let successCount = 0;
  let errorCount = 0;
  const errors: string[] = [];
  const uploadResults: UploadResultInfo[] = [];
  
  try {
    for (const analysis of validAnalyses) {
      try {
        const formData = new FormData();
        formData.append('file', analysis.file);
        appendRequiredBankCode(formData, analysis.bankCode, analysis.bankAlias);
        appendUploadCommonFields(formData);
        formData.append('headerRowIndex', String(analysis.headerRowIndex));
        formData.append('memoColumns', JSON.stringify(analysis.selectedMemoColumns));
        formData.append('columnMapping', JSON.stringify(analysis.columnMapping));
        // 이미 매핑 정보를 보냈으므로 적요 선택 스킵
        formData.append('skipMemoSelection', 'true');
        
        const response = await bankbookApi.uploadExcel(props.memberCode, formData);
        
        if (response.data.success) {
          const resData = response.data.data || response.data;
          const count = resData.totalCount || resData.insertedCount || 0;
          totalCount += count;
          successCount++;
          
          // 성공 결과 저장
          uploadResults.push({
            bankCode: analysis.bankCode,
            bankAlias: analysis.bankAlias,
            fileName: analysis.file.name,
            count,
            success: true
          });
        } else {
          errorCount++;
          const errMsg = response.data.message || '업로드 실패';
          errors.push(`${analysis.bankAlias}: ${errMsg}`);
          console.error(`[빠른 업로드] ${analysis.bankCode} 실패:`, response.data.message);
          
          // 실패 결과 저장
          uploadResults.push({
            bankCode: analysis.bankCode,
            bankAlias: analysis.bankAlias,
            fileName: analysis.file.name,
            count: 0,
            success: false,
            message: errMsg
          });
        }
      } catch (err: any) {
        errorCount++;
        const errMsg = err.message || '네트워크 오류';
        errors.push(`${analysis.bankAlias}: ${errMsg}`);
        console.error(`[빠른 업로드] ${analysis.bankCode} 에러:`, err);
        
        // 에러 결과 저장
        uploadResults.push({
          bankCode: analysis.bankCode,
          bankAlias: analysis.bankAlias,
          fileName: analysis.file.name,
          count: 0,
          success: false,
          message: errMsg
        });
      }
    }
    
    quickUploadResult.value = { totalCount, successCount, errorCount };
    
    if (errors.length > 0) {
      console.warn('[빠른 업로드] 일부 실패:', errors);
    }
    
    // 업로드 완료 시 부모에 알림 + 모달 닫기
    if (successCount > 0) {
      emit('saved', []);
    }
    
    // 업로드 결과 상세 정보 전달 및 모달 닫기
    emit('uploadComplete', uploadResults);
    dialogOpen.value = false;
    
  } finally {
    isQuickUploading.value = false;
  }
};

// 기존 빠른 업로드 (사용 안 함 - 호환성 유지)
const processQuickUpload = async () => {
  // 이제 analyzeQuickUploadFiles -> processQuickUploadWithMapping 흐름 사용
  await analyzeQuickUploadFiles();
};

// 분석 상태 초기화 (파일 변경/제거 시)
const resetAnalysisState = () => {
  // 헤더 선택 초기화
  needHeaderSelection.value = false;
  headerPreviewData.value = null;
  selectedHeaderRowIndex.value = null;
  // 적요 컬럼 선택 초기화
  needMemoSelection.value = false;
  memoSelectionData.value = null;
  selectedMemoColumns.value = [];
  selectedMemoCells.value = {};
  // 진행 상태 초기화
  isProcessing.value = false;
  processComplete.value = false;
  processStatus.value = { message: '' };
};

const handleFileSelect = (e: Event) => {
  const input = e.target as HTMLInputElement;
  if (input.files && input.files[0]) {
    // 파일이 변경되면 분석 상태 초기화
    resetAnalysisState();
    excelFile.value = input.files[0];
  }
};

const handleDrop = (e: DragEvent) => {
  isDragOver.value = false;
  if (e.dataTransfer?.files && e.dataTransfer.files[0]) {
    const file = e.dataTransfer.files[0];
    const ext = file.name.split('.').pop()?.toLowerCase();
    if (['xlsx', 'xls', 'csv'].includes(ext || '')) {
      // 파일이 변경되면 분석 상태 초기화
      resetAnalysisState();
      excelFile.value = file;
    } else {
      alert('엑셀 파일(.xlsx, .xls) 또는 CSV 파일만 업로드 가능합니다.');
    }
  }
};

const removeFile = () => {
  excelFile.value = null;
  resetAnalysisState();
  // 파일 입력 초기화
  if (fileInputRef.value) {
    fileInputRef.value.value = '';
  }
};

// 파일 미리보기 로드 (헤더 행 선택용)
const loadFilePreview = async () => {
  if (!excelFile.value) return;
  
  isLoadingPreview.value = true;
  
  try {
    const formDataObj = new FormData();
    formDataObj.append('file', excelFile.value);
    formDataObj.append('previewOnly', 'true');
    formDataObj.append('sheetIndex', String(selectedSheetIndex.value));
    
    const res = await bankbookApi.uploadExcel(props.memberCode, formDataObj);
    
    if (res.data?.previewData) {
      headerPreviewData.value = res.data.previewData;
      needHeaderSelection.value = true;
      selectedHeaderRowIndex.value = res.data.suggestedHeaderRow ?? null;
      // 시트 목록 저장
      if (res.data.sheetNames) {
        sheetNames.value = res.data.sheetNames;
      }
    } else {
      // 미리보기 데이터가 없으면 바로 분석 진행
      processExcelData(false);
    }
  } catch (error) {
    console.error('미리보기 로드 실패:', error);
    // 실패 시 바로 분석 진행
    processExcelData(false);
  } finally {
    isLoadingPreview.value = false;
  }
};

// 시트 변경 시 미리보기 다시 로드
const onSheetChange = async (index: number) => {
  selectedSheetIndex.value = index;
  selectedHeaderRowIndex.value = null;
  await loadFilePreview();
};

const selectLearningHeaderRow = (rowIdx: number) => {
  selectedHeaderRowIndex.value = rowIdx;
};

const cancelHeaderSelection = () => {
  needHeaderSelection.value = false;
  headerPreviewData.value = null;
  selectedHeaderRowIndex.value = null;
  sheetNames.value = [];
  selectedSheetIndex.value = 0;
};

const confirmHeaderSelection = async () => {
  if (selectedHeaderRowIndex.value === null) return;
  
  needHeaderSelection.value = false;
  // 선택한 헤더 행 인덱스를 사용하여 분석 진행
  await processExcelDataWithHeader(selectedHeaderRowIndex.value);
};

const processExcelDataWithHeader = async (headerRowIndex: number) => {
  if (!excelFile.value) return;
  if (!canUpload.value) {
    alert('통장을 선택해주세요.');
    return;
  }
  
  isProcessing.value = true;
  processComplete.value = false;
  processStatus.value = { message: '파일 분석 중...' };
  
  try {
    const formDataObj = new FormData();
    formDataObj.append('file', excelFile.value);
    appendUploadCommonFields(formDataObj);
    formDataObj.append('headerRowIndex', headerRowIndex.toString());
    formDataObj.append('sheetIndex', String(selectedSheetIndex.value));
    appendRequiredBankCode(formDataObj, selectedUploadBankCode.value);
    
    const res = await bankbookApi.uploadExcel(props.memberCode, formDataObj);
    
    if (res.data?.needMemoSelection) {
      isProcessing.value = false;
      needMemoSelection.value = true;
      memoSelectionData.value = {
        headers: res.data.headers,
        sampleData: res.data.sampleData,
        headerRowIndex: res.data.headerRowIndex,
        columnMapping: res.data.columnMapping,
        autoMemoIndex: res.data.autoMemoIndex
      };
      if (res.data.autoMemoIndex !== undefined && res.data.autoMemoIndex !== null) {
        selectedMemoColumns.value = [res.data.autoMemoIndex];
      } else {
        selectedMemoColumns.value = [];
      }
      return;
    }
    
    if (res.data?.data) {
      const result = res.data.data;
      processResult.value = {
        incomeCount: result.incomeCount || 0,
        incomeTotal: result.incomeTotal || 0,
        expenseCount: result.expenseCount || 0,
        expenseTotal: result.expenseTotal || 0,
        totalCount: result.totalCount || 0
      };
      processStatus.value = { message: '처리 완료!', current: result.totalCount, total: result.totalCount };
      processComplete.value = true;
      
      // 항상 saved 이벤트 emit (부모에서 새로고침하도록)
      emit('saved', result.items || []);
    }
  } catch (error: any) {
    console.error('처리 오류:', error);
    processStatus.value = { message: error.response?.data?.message || '처리 실패' };
  } finally {
    if (!processComplete.value && !needMemoSelection.value) {
      isProcessing.value = false;
    }
  }
};

const processExcelData = async (withMemoColumns = false) => {
  if (!excelFile.value) return;
  if (!canUpload.value) {
    alert('통장을 선택해주세요.');
    return;
  }
  
  isProcessing.value = true;
  processComplete.value = false;
  processStatus.value = { message: '파일 분석 중...' };
  
  try {
    const formDataObj = new FormData();
    formDataObj.append('file', excelFile.value);
    appendUploadCommonFields(formDataObj);
    appendRequiredBankCode(formDataObj, selectedUploadBankCode.value);
    
    if (withMemoColumns && selectedMemoColumns.value.length > 0) {
      formDataObj.append('memoColumns', JSON.stringify(selectedMemoColumns.value));
      if (Object.keys(selectedMemoCells.value).length > 0) {
        formDataObj.append('memoCellOverrides', JSON.stringify(selectedMemoCells.value));
      }
      if (memoSelectionData.value?.headerRowIndex !== undefined) {
        formDataObj.append('headerRowIndex', String(memoSelectionData.value.headerRowIndex));
      }
    }
    
    const res = await bankbookApi.uploadExcel(props.memberCode, formDataObj);
    
    if (res.data?.needMemoSelection) {
      isProcessing.value = false;
      needMemoSelection.value = true;
      memoSelectionData.value = {
        headers: res.data.headers,
        sampleData: res.data.sampleData,
        headerRowIndex: res.data.headerRowIndex,
        columnMapping: res.data.columnMapping,
        autoMemoIndex: res.data.autoMemoIndex
      };
      if (res.data.autoMemoIndex !== undefined && res.data.autoMemoIndex !== null) {
        selectedMemoColumns.value = [res.data.autoMemoIndex];
      } else {
        selectedMemoColumns.value = [];
      }
      return;
    }
    
    if (res.data?.data) {
      const result = res.data.data;
      processResult.value = {
        incomeCount: result.incomeCount || 0,
        incomeTotal: result.incomeTotal || 0,
        expenseCount: result.expenseCount || 0,
        expenseTotal: result.expenseTotal || 0,
        totalCount: result.totalCount || 0
      };
      processStatus.value = {
        message: '처리 완료!',
        current: result.totalCount,
        total: result.totalCount
      };
      processComplete.value = true;
      
      // 항상 saved 이벤트 emit (부모에서 새로고침하도록)
      emit('saved', result.items || []);
    }
  } catch (error: any) {
    console.error('엑셀 처리 오류:', error);
    processStatus.value = { message: error.response?.data?.message || '처리 실패' };
  } finally {
    if (!processComplete.value && !needMemoSelection.value) {
      isProcessing.value = false;
    }
  }
};

const toggleMemoColumn = (index: number) => {
  const idx = selectedMemoColumns.value.indexOf(index);
  
  // 해당 컬럼의 개별 셀 오버라이드 모두 제거
  Object.keys(selectedMemoCells.value).forEach(rowIdxStr => {
    const rowIdx = parseInt(rowIdxStr);
    if (selectedMemoCells.value[rowIdx]?.[index] !== undefined) {
      delete selectedMemoCells.value[rowIdx][index];
      // 해당 행에 더 이상 오버라이드가 없으면 행 자체를 삭제
      if (Object.keys(selectedMemoCells.value[rowIdx]).length === 0) {
        delete selectedMemoCells.value[rowIdx];
      }
    }
  });
  // 반응성 트리거
  selectedMemoCells.value = { ...selectedMemoCells.value };
  
  if (idx === -1) {
    selectedMemoColumns.value.push(index);
  } else {
    selectedMemoColumns.value.splice(idx, 1);
  }
};

const isCellSelected = (rowIdx: number, colIdx: number): boolean => {
  const isColumnSelected = selectedMemoColumns.value.includes(colIdx);
  const cellOverride = selectedMemoCells.value[rowIdx]?.[colIdx];
  if (cellOverride !== undefined) return cellOverride;
  return isColumnSelected;
};

const hasRowOverride = (rowIdx: number): boolean => {
  return selectedMemoCells.value[rowIdx] !== undefined && 
         Object.keys(selectedMemoCells.value[rowIdx]).length > 0;
};

const toggleCellSelection = (rowIdx: number, colIdx: number) => {
  const isColumnSelected = selectedMemoColumns.value.includes(colIdx);
  const currentCellOverride = selectedMemoCells.value[rowIdx]?.[colIdx];
  
  // 현재 셀의 실제 선택 상태
  const currentState = currentCellOverride !== undefined ? currentCellOverride : isColumnSelected;
  // 토글 후 새로운 상태
  const newState = !currentState;
  
  // 새로운 상태가 컬럼 기본 선택 상태와 같으면 오버라이드 제거
  if (newState === isColumnSelected) {
    // 오버라이드 제거
    if (selectedMemoCells.value[rowIdx]) {
      delete selectedMemoCells.value[rowIdx][colIdx];
      // 해당 행에 더 이상 오버라이드가 없으면 행 자체를 삭제
      if (Object.keys(selectedMemoCells.value[rowIdx]).length === 0) {
        delete selectedMemoCells.value[rowIdx];
      }
    }
  } else {
    // 오버라이드 추가
    if (!selectedMemoCells.value[rowIdx]) {
      selectedMemoCells.value[rowIdx] = {};
    }
    selectedMemoCells.value[rowIdx][colIdx] = newState;
  }
  
  // 트리거 반응성
  selectedMemoCells.value = { ...selectedMemoCells.value };
};

const resetCellSelection = () => {
  selectedMemoCells.value = {};
};

const getCellMemoResult = (rowIdx: number, row: string[]): string => {
  const headers = memoSelectionData.value?.headers || [];
  const activeCols: number[] = [];
  
  headers.forEach((header) => {
    const colIdx = header.index;
    if (isCellSelected(rowIdx, colIdx)) {
      activeCols.push(colIdx);
    }
  });
  
  if (activeCols.length === 0) return '';
  
  return activeCols
    .sort((a, b) => a - b)
    .map(colIdx => row[colIdx])
    .filter(v => v && v.trim())
    .join(' ') || '';
};

const cancelMemoSelection = () => {
  needMemoSelection.value = false;
  memoSelectionData.value = null;
  selectedMemoColumns.value = [];
  selectedMemoCells.value = {};
  isProcessing.value = false;
};

// ============================================
// 검색 관련 메서드
// ============================================

const applyGroupSearch = () => {
  // 검색어 입력 후 엔터 시 처리 (현재는 실시간 검색이므로 별도 처리 없음)
};

const clearGroupSearch = () => {
  groupSearchQuery.value = '';
};

const isSearchMatch = (group: MemoGroup): boolean => {
  if (!groupSearchQuery.value.trim()) return false;
  const query = groupSearchQuery.value.toLowerCase().trim();
  if (group.keyword.toLowerCase().includes(query)) return true;
  return group.memos.some(m => m.memo.toLowerCase().includes(query));
};

const getOriginalIndex = (group: MemoGroup): number => {
  return memoGroups.value.findIndex(g => g.keyword === group.keyword && g.gubun === group.gubun);
};

const openBulkAssignModal = () => {
  bulkAssignGubun.value = 'all';
  bulkAssignScode.value = null;
  bulkRegisterAsKeyword.value = true;
  showBulkAssignModal.value = true;
};

const applyBulkAssign = () => {
  if (!bulkAssignScode.value) return;
  
  const targetGroups = searchResultGroups.value.filter(g => {
    if (bulkAssignGubun.value === 'all') return true;
    return g.gubun === bulkAssignGubun.value;
  });
  
  // 각 그룹에 계정 적용 (새 배열로 교체하여 반응성 보장)
  const updatedGroups = [...memoGroups.value];
  targetGroups.forEach(group => {
    const idx = getOriginalIndex(group);
    if (idx !== -1) {
      updatedGroups[idx] = { ...updatedGroups[idx], selectedScode: bulkAssignScode.value! };
    }
  });
  memoGroups.value = updatedGroups;
  
  // 키워드 등록 옵션이 켜져 있으면 registeredKeywords에 추가
  if (bulkRegisterAsKeyword.value && groupSearchQuery.value.trim()) {
    const scodeName = getScodeName(bulkAssignScode.value, bulkAssignGubun.value === 'IN' ? 'IN' : 'OUT');
    
    // 수입/지출 각각에 대해 키워드 등록
    if (bulkAssignGubun.value === 'all') {
      // 수입과 지출 모두에 등록
      const hasIncome = targetGroups.some(g => g.gubun === 'IN');
      const hasExpense = targetGroups.some(g => g.gubun === 'OUT');
      
      if (hasIncome) {
        const exists = registeredKeywords.value.some(
          rk => rk.keyword === groupSearchQuery.value.trim() && rk.gubun === 'IN'
        );
        if (!exists) {
          registeredKeywords.value.push({
            gubun: 'IN',
            keyword: groupSearchQuery.value.trim(),
            scode: bulkAssignScode.value!,
            scodeName: scodeName
          });
        }
      }
      if (hasExpense) {
        const exists = registeredKeywords.value.some(
          rk => rk.keyword === groupSearchQuery.value.trim() && rk.gubun === 'OUT'
        );
        if (!exists) {
          registeredKeywords.value.push({
            gubun: 'OUT',
            keyword: groupSearchQuery.value.trim(),
            scode: bulkAssignScode.value!,
            scodeName: scodeName
          });
        }
      }
    } else {
      const exists = registeredKeywords.value.some(
        rk => rk.keyword === groupSearchQuery.value.trim() && rk.gubun === bulkAssignGubun.value
      );
      if (!exists) {
        registeredKeywords.value.push({
          gubun: bulkAssignGubun.value as 'IN' | 'OUT',
          keyword: groupSearchQuery.value.trim(),
          scode: bulkAssignScode.value!,
          scodeName: scodeName
        });
      }
    }
  }
  
  showBulkAssignModal.value = false;
  
  // 저장 완료 스낵바 표시
  saveSnackbarMessage.value = `${targetGroups.length}개 그룹에 계정이 지정되었습니다`;
  showSaveSnackbar.value = true;
};

const getScodeName = (scode: string | null, gubun: 'IN' | 'OUT'): string => {
  if (!scode) return '';
  const list = gubun === 'IN' ? incomeCodeList.value : expenseCodeList.value;
  const found = list.find(item => item.scode === scode);
  return found?.sname || scode;
};

const showLearningStep = async () => {
  if (selectedMemoColumns.value.length === 0) {
    alert('적요 컬럼을 하나 이상 선택해주세요.');
    return;
  }
  
  const memos: Array<{ memo: string; gubun: string; price: number; date?: string }> = [];
  const sampleData = memoSelectionData.value?.sampleData || [];
  const columnMapping = memoSelectionData.value?.columnMapping || {};
  
  sampleData.forEach((row, rowIdx) => {
    const memo = getCellMemoResult(rowIdx, row);
    if (!memo) return;
    
    let gubun = 'OUT';
    let price = 0;
    let date = '';
    
    // 날짜 추출
    if (columnMapping.date !== undefined) {
      const dateVal = row[columnMapping.date];
      if (dateVal) {
        date = String(dateVal);
      }
    }
    
    if (columnMapping.income !== undefined && columnMapping.expense !== undefined) {
      const incomeVal = parseFloat(String(row[columnMapping.income] || '0').replace(/[^0-9.-]/g, ''));
      const expenseVal = parseFloat(String(row[columnMapping.expense] || '0').replace(/[^0-9.-]/g, ''));
      
      if (incomeVal !== 0) {
        // 입금 컬럼 → 수입 (마이너스도 수입으로 유지)
        gubun = 'IN';
        price = incomeVal; // 마이너스 그대로 유지
      } else if (expenseVal !== 0) {
        // 출금 컬럼 → 지출 (마이너스도 지출로 유지)
        gubun = 'OUT';
        price = expenseVal; // 마이너스 그대로 유지
      }
    } else if (columnMapping.amount !== undefined) {
      const amountVal = parseFloat(String(row[columnMapping.amount] || '0').replace(/[^0-9.-]/g, ''));
      price = amountVal; // 마이너스 그대로 유지
      // 음수면 지출, 양수면 수입으로 추정 (단일 금액 컬럼)
      gubun = amountVal < 0 ? 'OUT' : 'IN';
    }
    
    memos.push({ memo, gubun, price, date });
  });
  
  if (memos.length === 0) {
    alert('추출된 적요가 없습니다.');
    return;
  }
  
  isLoadingGroups.value = true;
  try {
    const res = await bankbookApi.groupMemos(props.memberCode, {
      memos,
      bizGubun: props.bizGubun,
      scope: learningScope.value,
      year: props.currentYear
    });
    
    if (res.data?.data?.groups) {
      memoGroups.value = res.data.data.groups.map((g: any) => {
        // 기존에 등록한 키워드가 있으면 해당 계정 적용
        const registeredMatch = registeredKeywords.value.find(
          rk => rk.keyword === g.keyword && rk.gubun === g.gubun
        );
        
        return {
          ...g,
          selectedScode: registeredMatch?.scode || g.learned?.scode || undefined,
          isEditing: false,
          customKeywords: []
        };
      });
      
      needMemoSelection.value = false;
      currentStep.value = 'learning';
      selectedGroupIdx.value = memoGroups.value.length > 0 ? 0 : null;
    }
  } catch (error: any) {
    console.error('적요 그룹화 오류:', error);
    alert('적요 그룹화에 실패했습니다.');
  } finally {
    isLoadingGroups.value = false;
  }
};

const changeLearningScope = async (scope: 'facility' | 'bizGubun' | 'all') => {
  learningScope.value = scope;
  
  const memos = memoGroups.value.flatMap(g => g.memos);
  if (memos.length === 0) return;
  
  isLoadingGroups.value = true;
  try {
    const res = await bankbookApi.groupMemos(props.memberCode, {
      memos,
      bizGubun: props.bizGubun,
      scope,
      year: props.currentYear
    });
    
    if (res.data?.data?.groups) {
      const prevSelections: Record<string, { scode: string; keywords: string[] }> = {};
      memoGroups.value.forEach(g => {
        const key = `${g.gubun}:${g.keyword}`;
        prevSelections[key] = {
          scode: g.selectedScode || '',
          keywords: g.customKeywords || []
        };
      });
      
      memoGroups.value = res.data.data.groups.map((g: any) => {
        const key = `${g.gubun}:${g.keyword}`;
        const prev = prevSelections[key];
        return {
          ...g,
          selectedScode: prev?.scode || g.learned?.scode || undefined,
          isEditing: false,
          customKeywords: prev?.keywords || []
        };
      });
      
      if (selectedGroupIdx.value !== null && selectedGroupIdx.value >= memoGroups.value.length) {
        selectedGroupIdx.value = memoGroups.value.length > 0 ? 0 : null;
      }
    }
  } catch (error) {
    console.error('범위 변경 오류:', error);
  } finally {
    isLoadingGroups.value = false;
  }
};

const getLearningSourceLabel = (source: string): string => {
  switch (source) {
    case 'facility': return '이 시설';
    case 'otherFacility': return '다른 시설';
    case 'allBizGubun': return '다른 사업';
    default: return source;
  }
};

const selectGroup = (idx: number) => {
  selectedGroupIdx.value = idx;
};

// 그룹 카드 클릭 핸들러
const onGroupCardClick = (group: MemoGroup, event: MouseEvent) => {
  const idx = getOriginalIndex(group);
  if (isMultiSelectMode.value) {
    toggleGroupSelection(idx);
  } else {
    selectGroup(idx);
  }
};

// 다중 선택 모드 변경 시
const onMultiSelectModeChange = () => {
  if (!isMultiSelectMode.value) {
    selectedGroupIndices.value.clear();
  }
};

// 그룹 선택 토글
const toggleGroupSelection = (idx: number) => {
  if (selectedGroupIndices.value.has(idx)) {
    selectedGroupIndices.value.delete(idx);
  } else {
    selectedGroupIndices.value.add(idx);
  }
  // 반응성 트리거를 위해 새 Set 생성
  selectedGroupIndices.value = new Set(selectedGroupIndices.value);
};

// 전체 선택/해제 토글
const toggleSelectAll = () => {
  if (isAllDisplayedSelected.value) {
    // 전체 해제
    displayedGroups.value.forEach(group => {
      selectedGroupIndices.value.delete(getOriginalIndex(group));
    });
  } else {
    // 전체 선택
    displayedGroups.value.forEach(group => {
      selectedGroupIndices.value.add(getOriginalIndex(group));
    });
  }
  selectedGroupIndices.value = new Set(selectedGroupIndices.value);
};

// 다중 선택 일괄 지정 모달 열기
const openBulkAssignSelectedModal = () => {
  if (selectedGroupIndices.value.size === 0) return;
  bulkSelectedGubun.value = 'all';
  bulkSelectedScode.value = null;
  showBulkAssignSelectedModal.value = true;
};

// 다중 선택 일괄 계정 지정 적용
const applyBulkAssignSelected = () => {
  if (!bulkSelectedScode.value) return;
  
  let appliedCount = 0;
  const updatedGroups = [...memoGroups.value];
  
  selectedGroupIndices.value.forEach(idx => {
    const group = updatedGroups[idx];
    if (!group) return;
    
    // 구분 필터 적용
    if (bulkSelectedGubun.value !== 'all' && group.gubun !== bulkSelectedGubun.value) return;
    
    // 계정 지정 (새 객체로 교체하여 반응성 보장)
    updatedGroups[idx] = { ...group, selectedScode: bulkSelectedScode.value ?? undefined };
    appliedCount++;
  });
  
  // 배열 전체를 새로 할당하여 반응성 트리거
  memoGroups.value = updatedGroups;
  
  // 선택 초기화 및 모달 닫기
  selectedGroupIndices.value.clear();
  selectedGroupIndices.value = new Set();
  showBulkAssignSelectedModal.value = false;
  isMultiSelectMode.value = false;
  
  // 저장 완료 스낵바 표시
  saveSnackbarMessage.value = `${appliedCount}개 그룹에 계정이 지정되었습니다`;
  showSaveSnackbar.value = true;
};

const getScodeNameForGroup = (group: MemoGroup): string => {
  if (group.selectedScode) {
    const list = group.gubun === 'IN' ? incomeCodeList.value : expenseCodeList.value;
    const found = list.find(c => c.scode === group.selectedScode);
    return found?.sname || group.selectedScode;
  }
  return group.learned?.scode_name || group.learned?.scode || '';
};

const onScodeSelect = (idx: number) => {
  const group = memoGroups.value[idx];
  if (!group?.selectedScode) return;
  
  const scodeName = getScodeNameForGroup(group);
  
  // 다중 선택 모드이고, 선택된 항목이 있으면 모두에게 적용
  if (isMultiSelectMode.value && selectedGroupIndices.value.size > 0) {
    // 선택된 항목 중 같은 구분(수입/지출)인 것들에만 적용
    const updatedGroups = [...memoGroups.value];
    let appliedCount = 0;
    
    selectedGroupIndices.value.forEach(selectedIdx => {
      const targetGroup = updatedGroups[selectedIdx];
      if (targetGroup && targetGroup.gubun === group.gubun) {
        updatedGroups[selectedIdx] = { ...targetGroup, selectedScode: group.selectedScode };
        appliedCount++;
      }
    });
    
    memoGroups.value = updatedGroups;
    
    // 선택 초기화
    selectedGroupIndices.value.clear();
    selectedGroupIndices.value = new Set();
    isMultiSelectMode.value = false;
    
    saveSnackbarMessage.value = `${appliedCount}개 그룹에 "${scodeName}" 지정됨`;
  } else {
    saveSnackbarMessage.value = `"${group.keyword}" → ${scodeName} 지정됨`;
  }
  
  showSaveSnackbar.value = true;
};

// 등록된 키워드 삭제
const removeRegisteredKeyword = (idx: number) => {
  registeredKeywords.value.splice(idx, 1);
};

const backToMemoSelection = () => {
  currentStep.value = 'upload';
  needMemoSelection.value = true;
  selectedGroupIdx.value = null;
};

// 확인 다이얼로그 표시
const showConfirmDialog = (type: 'skip' | 'saveAndRegister') => {
  confirmDialogType.value = type;
  confirmDialogOpen.value = true;
};

// 확인된 액션 실행
const executeConfirmedAction = () => {
  confirmDialogOpen.value = false;
  if (confirmDialogType.value === 'skip') {
    skipLearningAndRegister();
  } else {
    saveLearnAndRegister();
  }
};

const skipLearningAndRegister = async () => {
  isProcessing.value = true;
  processStatus.value = { message: '데이터 등록 중...' };
  
  try {
    const formDataObj = new FormData();
    formDataObj.append('file', excelFile.value!);
    appendUploadCommonFields(formDataObj);
    appendRequiredBankCode(formDataObj, selectedUploadBankCode.value);
    formDataObj.append('memoColumns', JSON.stringify(selectedMemoColumns.value));
    if (Object.keys(selectedMemoCells.value).length > 0) {
      formDataObj.append('memoCellOverrides', JSON.stringify(selectedMemoCells.value));
    }
    if (memoSelectionData.value?.headerRowIndex !== undefined) {
      formDataObj.append('headerRowIndex', String(memoSelectionData.value.headerRowIndex));
    }
    
    const res = await bankbookApi.uploadExcel(props.memberCode, formDataObj);
    
    if (res.data?.data) {
      const result = res.data.data;
      processResult.value = {
        incomeCount: result.incomeCount || 0,
        incomeTotal: result.incomeTotal || 0,
        expenseCount: result.expenseCount || 0,
        expenseTotal: result.expenseTotal || 0,
        totalCount: result.totalCount || 0
      };
      processStatus.value = { message: '처리 완료!', current: result.totalCount, total: result.totalCount };
      processComplete.value = true;
      
      // 항상 saved 이벤트 emit (부모에서 새로고침하도록)
      emit('saved', result.items || []);
      
      // 완료 후 모달 자동 닫기
      setTimeout(() => {
        closeDialog();
      }, 500);
    }
  } catch (error: any) {
    console.error('처리 오류:', error);
    processStatus.value = { message: '처리 실패' };
  } finally {
    if (!processComplete.value) {
      isProcessing.value = false;
    }
  }
};

const saveLearnAndRegister = async () => {
  isProcessing.value = true;
  processComplete.value = false;
  processStatus.value = { message: '학습 데이터 저장 중...' };
  
  try {
    // 1. 학습 데이터 저장
    const learnItems: Array<{
      m_code: string | number;
      biz_gubun?: string;
      gubun: string;
      keyword: string;
      scode: string;
    }> = [];
    
    // 적요 그룹에서 선택한 계정
    memoGroups.value.forEach(group => {
      const scode = group.selectedScode || group.learned?.scode;
      if (scode) {
        // 기본 키워드 (적요 전체)
        learnItems.push({
          m_code: props.memberCode,
          biz_gubun: props.bizGubun,
          gubun: group.gubun,
          keyword: group.keyword,
          scode
        });
      }
    });
    
    // 직접 등록한 키워드들
    registeredKeywords.value.forEach(rk => {
      learnItems.push({
        m_code: props.memberCode,
        biz_gubun: props.bizGubun,
        gubun: rk.gubun,
        keyword: rk.keyword,
        scode: rk.scode
      });
    });
    
    if (learnItems.length > 0) {
      await bankbookApi.learnBatch(learnItems);
    }
    
    // 2. 엑셀 데이터 등록
    processStatus.value = { message: '데이터 등록 중...' };
    
    const formDataObj = new FormData();
    formDataObj.append('file', excelFile.value!);
    appendUploadCommonFields(formDataObj);
    appendRequiredBankCode(formDataObj, selectedUploadBankCode.value);
    formDataObj.append('memoColumns', JSON.stringify(selectedMemoColumns.value));
    if (Object.keys(selectedMemoCells.value).length > 0) {
      formDataObj.append('memoCellOverrides', JSON.stringify(selectedMemoCells.value));
    }
    if (memoSelectionData.value?.headerRowIndex !== undefined) {
      formDataObj.append('headerRowIndex', String(memoSelectionData.value.headerRowIndex));
    }
    
    const res = await bankbookApi.uploadExcel(props.memberCode, formDataObj);
    
    if (res.data?.data) {
      const result = res.data.data;
      processResult.value = {
        incomeCount: result.incomeCount || 0,
        incomeTotal: result.incomeTotal || 0,
        expenseCount: result.expenseCount || 0,
        expenseTotal: result.expenseTotal || 0,
        totalCount: result.totalCount || 0
      };
      processStatus.value = { message: '처리 완료!', current: result.totalCount, total: result.totalCount };
      processComplete.value = true;
      
      // 항상 saved 이벤트 emit (부모에서 새로고침하도록)
      emit('saved', result.items || []);
      
      // 완료 후 모달 자동 닫기
      setTimeout(() => {
        closeDialog();
      }, 500);
    }
  } catch (error: any) {
    console.error('처리 오류:', error);
    processStatus.value = { message: '처리 실패' };
  } finally {
    if (!processComplete.value) {
      isProcessing.value = false;
    }
  }
};

const closeDialog = () => {
  if (isProcessing.value && !processComplete.value) return;
  
  dialogOpen.value = false;
  
  setTimeout(() => {
    activeTab.value = 'excel';
    currentStep.value = 'upload';
    formData.value = {
      gubun: 'OUT',
      inout_date: `${props.currentYear}-${props.currentMonth}-01`,
      price: 0,
      memo: '',
      relAcc: '',
      bankCode: props.selectedBankCode || ''
    };
    prediction.value = null;
    predictionError.value = '';
    excelFile.value = null;
    isProcessing.value = false;
    processComplete.value = false;
    processStatus.value = { message: '' };
    needHeaderSelection.value = false;
    headerPreviewData.value = null;
    selectedHeaderRowIndex.value = null;
    needMemoSelection.value = false;
    memoSelectionData.value = null;
    selectedMemoColumns.value = [];
    selectedMemoCells.value = {};
    showLearning.value = false;
    memoGroups.value = [];
    learningScope.value = 'facility';
    selectedGroupIdx.value = null;
    groupFilter.value = 'all';
    registeredKeywords.value = [];
    groupSearchQuery.value = '';
    showBulkAssignModal.value = false;
    bulkAssignGubun.value = 'all';
    bulkAssignScode.value = null;
    bulkRegisterAsKeyword.value = true;
    // 통장 선택은 초기화하지 않음 (다음에 열 때 props에서 다시 설정됨)
    // 다중 파일 목록 초기화
    uploadFileList.value = [];
    // 빠른 업로드 상태 초기화
    quickUploadFiles.value = {};
    quickUploadComplete.value = false;
    quickUploadResult.value = { totalCount: 0, successCount: 0, errorCount: 0 };
    // 업로드 모드는 빠른 업로드로 초기화
    uploadMode.value = 'quick';
  }, 300);
};

watch(dialogOpen, (newVal) => {
  if (newVal) {
    formData.value.inout_date = `${props.currentYear}-${props.currentMonth}-01`;
    uploadBankUserTouched.value = false;

    // 다이얼로그 열릴 때만 초기 통장 설정 (사이드바 선택 → 기본값, 이후 사용자 변경 유지)
    let defaultBankCode = '';
    if (props.selectedBankCode) {
      selectedUploadBankCode.value = props.selectedBankCode;
      defaultBankCode = props.selectedBankCode;
    } else if (activeBankList.value.length === 1) {
      defaultBankCode = activeBankList.value[0].mb_code;
      selectedUploadBankCode.value = defaultBankCode;
    } else {
      selectedUploadBankCode.value = null;
    }
    formData.value.bankCode = defaultBankCode;
    // 다중 파일 목록 및 상태 초기화
    uploadFileList.value = [];
    processComplete.value = false;
    processStatus.value = { message: '' };
    processResult.value = { incomeCount: 0, incomeTotal: 0, expenseCount: 0, expenseTotal: 0, totalCount: 0 };
  }
});


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialogOpen.value,
    "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((dialogOpen).value = $event)),
    "max-width": activeTab.value === 'excel' ? '900' : '520',
    "content-class": "cashbook-upload-dialog",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["cashbook-upload-modal", { 'excel-mode': activeTab.value === 'excel' }]),
        "data-tour": "bb-test-upload-dialog"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_icon, {
              size: "24",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                _createTextVNode("mdi-upload", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", null, _toDisplayString(getHeaderTitle.value), 1),
            _createElementVNode("p", null, _toDisplayString(getHeaderSubtitle.value), 1)
          ]),
          _createElementVNode("button", {
            class: "help-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showHelpDialog.value = true)),
            title: "사용 설명서"
          }, [
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                _createTextVNode("mdi-help-circle-outline", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("button", {
            class: "close-btn",
            onClick: closeDialog,
            disabled: isProcessing.value && !processComplete.value
          }, [
            _createVNode(_component_v_icon, { size: "20" }, {
              default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                _createTextVNode("mdi-close", -1)
              ]))]),
              _: 1
            })
          ], 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["modal-tab excel", { active: activeTab.value === 'excel' }]),
            disabled: isProcessing.value && !processComplete.value,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'excel'))
          }, [
            _createVNode(_component_v_icon, { size: "16" }, {
              default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                _createTextVNode("mdi-file-excel", -1)
              ]))]),
              _: 1
            }),
            _cache[61] || (_cache[61] = _createTextVNode(" 엑셀 업로드 ", -1))
          ], 10, _hoisted_6),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["modal-tab", { active: activeTab.value === 'input' }]),
            disabled: isProcessing.value && !processComplete.value,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (activeTab.value = 'input'))
          }, [
            _createVNode(_component_v_icon, { size: "16" }, {
              default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                _createTextVNode("mdi-plus-circle", -1)
              ]))]),
              _: 1
            }),
            _cache[63] || (_cache[63] = _createTextVNode(" 직접 입력 ", -1))
          ], 10, _hoisted_7)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_icon, {
              size: "16",
              color: "#64748b"
            }, {
              default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                _createTextVNode("mdi-information-outline", -1)
              ]))]),
              _: 1
            }),
            _cache[65] || (_cache[65] = _createElementVNode("span", null, "통장·일자·금액·적요를 입력해 저장합니다. 계정은 통장내역 화면에서 지정할 수 있습니다.", -1))
          ]),
          _createVNode(_component_v_form, {
            ref_key: "formRef",
            ref: formRef
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["gubun-tab income", { active: formData.value.gubun === 'IN' }]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (formData.value.gubun = 'IN'))
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                        _createTextVNode("mdi-plus-circle", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[67] || (_cache[67] = _createTextVNode(" 수입 ", -1))
                  ], 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["gubun-tab expense", { active: formData.value.gubun === 'OUT' }]),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (formData.value.gubun = 'OUT'))
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                        _createTextVNode("mdi-minus-circle", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[69] || (_cache[69] = _createTextVNode(" 지출 ", -1))
                  ], 2)
                ])
              ]),
              (activeBankList.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _cache[71] || (_cache[71] = _createElementVNode("label", { class: "form-label required" }, "통장", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.bankCode) = $event)),
                      class: "form-input bank-select"
                    }, [
                      _cache[70] || (_cache[70] = _createElementVNode("option", { value: "" }, "통장을 선택하세요", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeBankList.value, (bank) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: bank.mb_code,
                          value: bank.mb_code
                        }, _toDisplayString(bank.mb_alias) + " (" + _toDisplayString(bank.mb_bank_name) + ") ", 9, _hoisted_13))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, formData.value.bankCode]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[72] || (_cache[72] = _createElementVNode("label", { class: "form-label required" }, "출납일자", -1)),
                  _createVNode(YmdDateInput, {
                    modelValue: formData.value.inout_date,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.inout_date) = $event)),
                    class: "form-input"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[74] || (_cache[74] = _createElementVNode("label", { class: "form-label required" }, "금액", -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["price-input-box", { focus: priceFocused.value }])
                  }, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "price-field",
                      value: formattedPrice.value,
                      onInput: handlePriceInput,
                      onKeydown: handlePriceKeydown,
                      onFocus: _cache[7] || (_cache[7] = ($event: any) => (priceFocused.value = true)),
                      onBlur: _cache[8] || (_cache[8] = ($event: any) => (priceFocused.value = false)),
                      placeholder: "0"
                    }, null, 40, _hoisted_17),
                    _cache[73] || (_cache[73] = _createElementVNode("span", { class: "price-unit" }, "원", -1))
                  ], 2)
                ])
              ]),
              (formData.value.inout_date && existingItemsForDate.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("label", _hoisted_19, [
                      _cache[75] || (_cache[75] = _createTextVNode(" 삽입 위치 ", -1)),
                      _createElementVNode("span", _hoisted_20, "(기존 " + _toDisplayString(existingItemsForDate.value.length) + "건)", 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["position-option", { active: insertPosition.value === 'first' }])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((insertPosition).value = $event)),
                          value: "first"
                        }, null, 512), [
                          [_vModelRadio, insertPosition.value]
                        ]),
                        _cache[76] || (_cache[76] = _createElementVNode("span", { class: "option-label" }, "맨 앞", -1))
                      ], 2),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(existingItemsForDate.value, (item, idx) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: item.cb_idx,
                          class: _normalizeClass(["position-option existing-item", { active: insertPosition.value === item.cb_idx }])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((insertPosition).value = $event)),
                            value: item.cb_idx
                          }, null, 8, _hoisted_22), [
                            [_vModelRadio, insertPosition.value]
                          ]),
                          _createElementVNode("span", _hoisted_23, _toDisplayString(idx + 1), 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(["option-gubun", item.cb_gubun === 'IN' ? 'income' : 'expense'])
                          }, _toDisplayString(item.cb_gubun === 'IN' ? '입' : '출'), 3),
                          _createElementVNode("span", _hoisted_24, _toDisplayString(item.cb_memo?.substring(0, 15) || '(적요없음)') + _toDisplayString(item.cb_memo?.length > 15 ? '...' : ''), 1),
                          _createElementVNode("span", _hoisted_25, _toDisplayString(Number(item.cb_price || 0).toLocaleString()), 1),
                          _cache[77] || (_cache[77] = _createElementVNode("span", { class: "option-suffix" }, "뒤에", -1))
                        ], 2))
                      }), 128)),
                      _createElementVNode("label", {
                        class: _normalizeClass(["position-option", { active: insertPosition.value === 'last' }])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((insertPosition).value = $event)),
                          value: "last"
                        }, null, 512), [
                          [_vModelRadio, insertPosition.value]
                        ]),
                        _cache[78] || (_cache[78] = _createElementVNode("span", { class: "option-label" }, "맨 뒤", -1)),
                        _cache[79] || (_cache[79] = _createElementVNode("span", { class: "option-default" }, "(기본)", -1))
                      ], 2)
                    ])
                  ]))
                : (isLoadingExistingItems.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_v_progress_circular, {
                          indeterminate: "",
                          size: "16",
                          width: "2"
                        }),
                        _cache[80] || (_cache[80] = _createElementVNode("span", null, "기존 내역 확인 중...", -1))
                      ])
                    ]))
                  : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_28, [
                _cache[81] || (_cache[81] = _createElementVNode("label", { class: "form-label required" }, "적요", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-input",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.memo) = $event)),
                  placeholder: "적요를 입력하세요 (예: 직원음료, 본인부담금 등)"
                }, null, 512), [
                  [_vModelText, formData.value.memo]
                ])
              ]),
              (formData.value.gubun === 'OUT')
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _cache[82] || (_cache[82] = _createElementVNode("label", { class: "form-label" }, "상대계정", -1)),
                    _createVNode(_component_v_autocomplete, {
                      modelValue: formData.value.relAcc,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.relAcc) = $event)),
                      items: props.incomeCodeList || [],
                      "item-title": "sname",
                      "item-value": "scode",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      placeholder: "어떤 수입에서 지출하는지 선택",
                      clearable: ""
                    }, null, 8, ["modelValue", "items"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 512)
        ], 512), [
          [_vShow, activeTab.value === 'input']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            (!props.bankList || props.bankList.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createVNode(_component_v_icon, {
                    size: "24",
                    color: "#f59e0b"
                  }, {
                    default: _withCtx(() => [...(_cache[83] || (_cache[83] = [
                      _createTextVNode("mdi-alert-circle", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[84] || (_cache[84] = _createElementVNode("div", { class: "warning-text" }, [
                    _createElementVNode("p", null, "등록된 통장이 없습니다."),
                    _createElementVNode("span", null, "먼저 \"통장 관리\"에서 통장을 등록해주세요.")
                  ], -1))
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_33, [
                    (quickUploadStep.value === 'select')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_34, [
                            _createVNode(_component_v_icon, {
                              size: "16",
                              color: "#1565c0"
                            }, {
                              default: _withCtx(() => [...(_cache[85] || (_cache[85] = [
                                _createTextVNode("mdi-information", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[86] || (_cache[86] = _createElementVNode("span", null, "통장별로 엑셀(또는 CSV) 파일을 선택한 뒤 업로드하세요. 계정은 통장내역 화면에서 지정할 수 있습니다.", -1))
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeBankList.value, (bank) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: bank.mb_code,
                                class: _normalizeClass(["bank-file-item", { 'has-file': quickUploadFiles.value[bank.mb_code] }])
                              }, [
                                _createElementVNode("div", _hoisted_36, [
                                  _createVNode(_component_v_icon, {
                                    size: "18",
                                    color: "#1565c0"
                                  }, {
                                    default: _withCtx(() => [...(_cache[87] || (_cache[87] = [
                                      _createTextVNode("mdi-bank", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("span", _hoisted_38, _toDisplayString(bank.mb_alias), 1),
                                    _createElementVNode("span", _hoisted_39, _toDisplayString(bank.mb_bank_name), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["file-dropzone-mini", { 'has-file': quickUploadFiles.value[bank.mb_code] }]),
                                    onClick: ($event: any) => (triggerQuickFileInput(bank.mb_code))
                                  }, [
                                    _createElementVNode("input", {
                                      ref_for: true,
                                      ref: el => setQuickFileInputRef(el, bank.mb_code),
                                      type: "file",
                                      accept: ".xlsx,.xls,.csv",
                                      onChange: e => handleQuickFileSelect(e, bank.mb_code),
                                      hidden: ""
                                    }, null, 40, _hoisted_42),
                                    (!quickUploadFiles.value[bank.mb_code])
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createVNode(_component_v_icon, {
                                            size: "16",
                                            color: "#94a3b8"
                                          }, {
                                            default: _withCtx(() => [...(_cache[88] || (_cache[88] = [
                                              _createTextVNode("mdi-file-plus", -1)
                                            ]))]),
                                            _: 1
                                          }),
                                          _cache[89] || (_cache[89] = _createElementVNode("span", null, "파일 선택", -1))
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createVNode(_component_v_icon, {
                                            size: "16",
                                            color: "#10b981"
                                          }, {
                                            default: _withCtx(() => [...(_cache[90] || (_cache[90] = [
                                              _createTextVNode("mdi-file-excel", -1)
                                            ]))]),
                                            _: 1
                                          }),
                                          _createElementVNode("span", _hoisted_43, _toDisplayString(quickUploadFiles.value[bank.mb_code].name), 1),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "btn-remove-mini",
                                            onClick: _withModifiers(($event: any) => (removeQuickFile(bank.mb_code)), ["stop"])
                                          }, [
                                            _createVNode(_component_v_icon, { size: "12" }, {
                                              default: _withCtx(() => [...(_cache[91] || (_cache[91] = [
                                                _createTextVNode("mdi-close", -1)
                                              ]))]),
                                              _: 1
                                            })
                                          ], 8, _hoisted_44)
                                        ], 64))
                                  ], 10, _hoisted_41)
                                ])
                              ], 2))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                              (quickUploadFileCount.value === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_47, "파일을 선택해주세요"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_48, [
                                    _createVNode(_component_v_icon, {
                                      size: "14",
                                      color: "#10b981"
                                    }, {
                                      default: _withCtx(() => [...(_cache[92] || (_cache[92] = [
                                        _createTextVNode("mdi-check-circle", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _createTextVNode(" " + _toDisplayString(quickUploadFileCount.value) + "개 파일 선택됨 ", 1)
                                  ]))
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn-quick-upload",
                              disabled: quickUploadFileCount.value === 0 || isAnalyzingFiles.value,
                              onClick: analyzeQuickUploadFiles
                            }, [
                              (isAnalyzingFiles.value)
                                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                    key: 0,
                                    indeterminate: "",
                                    size: "18",
                                    width: "2",
                                    color: "white"
                                  }))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createVNode(_component_v_icon, { size: "18" }, {
                                      default: _withCtx(() => [...(_cache[93] || (_cache[93] = [
                                        _createTextVNode("mdi-table-search", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _cache[94] || (_cache[94] = _createTextVNode(" 헤더 확인 ", -1))
                                  ], 64))
                            ], 8, _hoisted_49)
                          ])
                        ], 64))
                      : (quickUploadStep.value === 'confirm')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_50, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn-back",
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (quickUploadStep.value = 'select'))
                              }, [
                                _createVNode(_component_v_icon, { size: "16" }, {
                                  default: _withCtx(() => [...(_cache[95] || (_cache[95] = [
                                    _createTextVNode("mdi-arrow-left", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[96] || (_cache[96] = _createTextVNode(" 파일 선택으로 ", -1))
                              ]),
                              _createElementVNode("div", _hoisted_51, [
                                _createVNode(_component_v_icon, {
                                  size: "18",
                                  color: "#1565c0"
                                }, {
                                  default: _withCtx(() => [...(_cache[97] || (_cache[97] = [
                                    _createTextVNode("mdi-table-check", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createElementVNode("span", null, "헤더 확인 (" + _toDisplayString(quickFileAnalyses.value.length) + "개 파일)", 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_52, [
                              _createVNode(_component_v_icon, {
                                size: "14",
                                color: "#f59e0b"
                              }, {
                                default: _withCtx(() => [...(_cache[98] || (_cache[98] = [
                                  _createTextVNode("mdi-alert", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[99] || (_cache[99] = _createElementVNode("span", null, "각 파일의 컬럼 매핑을 확인하세요. 빨간색 표시는 필수 컬럼이 감지되지 않은 파일입니다.", -1))
                            ]),
                            _createElementVNode("div", _hoisted_53, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quickFileAnalyses.value, (analysis, idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: analysis.bankCode,
                                  class: _normalizeClass(["file-analysis-card", { 'is-invalid': !analysis.isValid, 'is-expanded': currentAnalysisIndex.value === idx }])
                                }, [
                                  _createElementVNode("div", {
                                    class: "analysis-card-header",
                                    onClick: ($event: any) => (toggleAnalysisCard(idx))
                                  }, [
                                    _createElementVNode("div", _hoisted_55, [
                                      _createVNode(_component_v_icon, {
                                        size: "18",
                                        color: analysis.isValid ? '#10b981' : '#ef4444'
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(analysis.isValid ? 'mdi-check-circle' : 'mdi-alert-circle'), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["color"]),
                                      _createElementVNode("div", _hoisted_56, [
                                        _createElementVNode("span", _hoisted_57, _toDisplayString(analysis.bankAlias), 1),
                                        _createElementVNode("span", _hoisted_58, _toDisplayString(analysis.file.name), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_59, [
                                      (analysis.isValid)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_60, " 날짜: " + _toDisplayString(analysis.columnMapping.date !== undefined ? '✓' : '✗') + " | 금액: " + _toDisplayString((analysis.columnMapping.income !== undefined || analysis.columnMapping.amount !== undefined) ? '✓' : '✗') + " | 적요: " + _toDisplayString(analysis.selectedMemoColumns.length > 0 ? '✓' : '✗'), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(analysis.errorMessage), 1)),
                                      _createVNode(_component_v_icon, {
                                        size: "18",
                                        color: "#64748b"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(currentAnalysisIndex.value === idx ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ])
                                  ], 8, _hoisted_54),
                                  (currentAnalysisIndex.value === idx)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                        (analysis.step === 'header')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                              _cache[106] || (_cache[106] = _createElementVNode("div", { class: "step-title" }, [
                                                _createElementVNode("span", { class: "step-badge" }, "1"),
                                                _createElementVNode("span", null, "헤더 행 선택"),
                                                _createElementVNode("span", { class: "step-hint" }, "날짜, 금액 등 컬럼명이 있는 행을 클릭하세요")
                                              ], -1)),
                                              _createElementVNode("div", _hoisted_64, [
                                                _createElementVNode("table", _hoisted_65, [
                                                  _createElementVNode("thead", null, [
                                                    _createElementVNode("tr", null, [
                                                      _cache[100] || (_cache[100] = _createElementVNode("th", { class: "col-select" }, null, -1)),
                                                      _cache[101] || (_cache[101] = _createElementVNode("th", { class: "col-rownum" }, null, -1)),
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getMaxColumns(analysis.previewRows), (colIdx) => {
                                                        return (_openBlock(), _createElementBlock("th", {
                                                          key: colIdx,
                                                          class: "col-header"
                                                        }, _toDisplayString(getExcelColumnName(colIdx - 1)), 1))
                                                      }), 128))
                                                    ])
                                                  ]),
                                                  _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(analysis.previewRows, (row, rowIdx) => {
                                                      return (_openBlock(), _createElementBlock("tr", {
                                                        key: rowIdx,
                                                        class: _normalizeClass({ 
                                    selected: analysis.selectedHeaderRowIndex === rowIdx,
                                    recommended: analysis.suggestedHeaderRowIndex === rowIdx
                                  }),
                                                        onClick: ($event: any) => (selectHeaderRow(idx, rowIdx))
                                                      }, [
                                                        _createElementVNode("td", _hoisted_67, [
                                                          _createElementVNode("div", _hoisted_68, [
                                                            (analysis.selectedHeaderRowIndex === rowIdx)
                                                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                                                  key: 0,
                                                                  size: "16",
                                                                  color: "#3b82f6"
                                                                }, {
                                                                  default: _withCtx(() => [...(_cache[102] || (_cache[102] = [
                                                                    _createTextVNode("mdi-check-circle", -1)
                                                                  ]))]),
                                                                  _: 1
                                                                }))
                                                              : (analysis.suggestedHeaderRowIndex === rowIdx)
                                                                ? (_openBlock(), _createElementBlock("span", {
                                                                    key: 1,
                                                                    class: _normalizeClass(["recommend-badge", analysis.detectionConfidence])
                                                                  }, _toDisplayString(analysis.detectionConfidence === 'high' ? '추천' : analysis.detectionConfidence === 'medium' ? '추정' : '?'), 3))
                                                                : (_openBlock(), _createBlock(_component_v_icon, {
                                                                    key: 2,
                                                                    size: "16",
                                                                    color: "#cbd5e1"
                                                                  }, {
                                                                    default: _withCtx(() => [...(_cache[103] || (_cache[103] = [
                                                                      _createTextVNode("mdi-circle-outline", -1)
                                                                    ]))]),
                                                                    _: 1
                                                                  }))
                                                          ])
                                                        ]),
                                                        _createElementVNode("td", _hoisted_69, _toDisplayString(rowIdx + 1), 1),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getMaxColumns(analysis.previewRows), (colIdx) => {
                                                          return (_openBlock(), _createElementBlock("td", {
                                                            key: colIdx,
                                                            class: "col-data"
                                                          }, _toDisplayString(row[colIdx - 1] !== undefined && row[colIdx - 1] !== null && row[colIdx - 1] !== '' ? row[colIdx - 1] : ''), 1))
                                                        }), 128))
                                                      ], 10, _hoisted_66))
                                                    }), 128))
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_70, [
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: "btn-next-step",
                                                  disabled: analysis.selectedHeaderRowIndex === null,
                                                  onClick: ($event: any) => (confirmHeaderRow(idx))
                                                }, [
                                                  _cache[105] || (_cache[105] = _createTextVNode(" 다음: 적요 선택 ", -1)),
                                                  _createVNode(_component_v_icon, { size: "16" }, {
                                                    default: _withCtx(() => [...(_cache[104] || (_cache[104] = [
                                                      _createTextVNode("mdi-arrow-right", -1)
                                                    ]))]),
                                                    _: 1
                                                  })
                                                ], 8, _hoisted_71)
                                              ])
                                            ]))
                                          : (analysis.step === 'memo')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                                _createElementVNode("div", _hoisted_73, [
                                                  _cache[109] || (_cache[109] = _createElementVNode("span", { class: "step-badge" }, "2", -1)),
                                                  _cache[110] || (_cache[110] = _createElementVNode("span", null, "적요 컬럼 선택", -1)),
                                                  _createElementVNode("button", {
                                                    type: "button",
                                                    class: "btn-back-step",
                                                    onClick: ($event: any) => (analysis.step = 'header')
                                                  }, [
                                                    _createVNode(_component_v_icon, { size: "14" }, {
                                                      default: _withCtx(() => [...(_cache[107] || (_cache[107] = [
                                                        _createTextVNode("mdi-arrow-left", -1)
                                                      ]))]),
                                                      _: 1
                                                    }),
                                                    _cache[108] || (_cache[108] = _createTextVNode(" 헤더 다시 선택 ", -1))
                                                  ], 8, _hoisted_74)
                                                ]),
                                                _createElementVNode("div", _hoisted_75, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["mapping-item role-date", { missing: analysis.columnMapping.date === undefined }])
                                                  }, [
                                                    _cache[111] || (_cache[111] = _createElementVNode("span", { class: "mapping-label" }, "날짜", -1)),
                                                    _createElementVNode("span", _hoisted_76, _toDisplayString(analysis.columnMapping.date !== undefined ? analysis.headers[analysis.columnMapping.date] : '미감지'), 1)
                                                  ], 2),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["mapping-item role-income", { missing: analysis.columnMapping.income === undefined && analysis.columnMapping.amount === undefined }])
                                                  }, [
                                                    _cache[112] || (_cache[112] = _createElementVNode("span", { class: "mapping-label" }, "입금", -1)),
                                                    _createElementVNode("span", _hoisted_77, _toDisplayString(analysis.columnMapping.income !== undefined ? analysis.headers[analysis.columnMapping.income] : (analysis.columnMapping.amount !== undefined ? '(금액)' : '미감지')), 1)
                                                  ], 2),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["mapping-item role-expense", { missing: analysis.columnMapping.expense === undefined && analysis.columnMapping.amount === undefined }])
                                                  }, [
                                                    _cache[113] || (_cache[113] = _createElementVNode("span", { class: "mapping-label" }, "출금", -1)),
                                                    _createElementVNode("span", _hoisted_78, _toDisplayString(analysis.columnMapping.expense !== undefined ? analysis.headers[analysis.columnMapping.expense] : (analysis.columnMapping.amount !== undefined ? '(금액)' : '미감지')), 1)
                                                  ], 2),
                                                  _createElementVNode("div", _hoisted_79, [
                                                    _cache[114] || (_cache[114] = _createElementVNode("span", { class: "mapping-label" }, "잔액", -1)),
                                                    _createElementVNode("span", _hoisted_80, _toDisplayString(analysis.columnMapping.balance !== undefined ? analysis.headers[analysis.columnMapping.balance] : '-'), 1)
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_81, [
                                                  _createElementVNode("div", _hoisted_82, [
                                                    _createVNode(_component_v_icon, {
                                                      size: "14",
                                                      color: "#1565c0"
                                                    }, {
                                                      default: _withCtx(() => [...(_cache[115] || (_cache[115] = [
                                                        _createTextVNode("mdi-text-box-outline", -1)
                                                      ]))]),
                                                      _: 1
                                                    }),
                                                    _cache[116] || (_cache[116] = _createElementVNode("span", null, "적요로 사용할 컬럼 선택 (복수 선택 가능)", -1))
                                                  ]),
                                                  _createElementVNode("div", _hoisted_83, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(analysis.headers, (header, hIdx) => {
                                                      return (_openBlock(), _createElementBlock("label", {
                                                        key: hIdx,
                                                        class: _normalizeClass(["memo-col-checkbox", { 
                                  checked: analysis.selectedMemoColumns.includes(hIdx),
                                  disabled: isReservedColumn(analysis, hIdx)
                                }])
                                                      }, [
                                                        _createElementVNode("input", {
                                                          type: "checkbox",
                                                          checked: analysis.selectedMemoColumns.includes(hIdx),
                                                          disabled: isReservedColumn(analysis, hIdx),
                                                          onChange: ($event: any) => (toggleQuickMemoColumn(idx, hIdx))
                                                        }, null, 40, _hoisted_84),
                                                        _createElementVNode("span", _hoisted_85, _toDisplayString(header || `컬럼${hIdx + 1}`), 1)
                                                      ], 2))
                                                    }), 128))
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_86, [
                                                  _cache[117] || (_cache[117] = _createElementVNode("div", { class: "preview-label-row" }, [
                                                    _createElementVNode("span", { class: "preview-label" }, "샘플 데이터 (상위 3행)"),
                                                    _createElementVNode("div", {
                                                      class: "preview-legend",
                                                      "aria-hidden": "true"
                                                    }, [
                                                      _createElementVNode("span", { class: "leg col-date" }, "날짜"),
                                                      _createElementVNode("span", { class: "leg col-income" }, "입금"),
                                                      _createElementVNode("span", { class: "leg col-expense" }, "출금"),
                                                      _createElementVNode("span", { class: "leg col-balance" }, "잔액"),
                                                      _createElementVNode("span", { class: "leg col-memo" }, "적요(선택)")
                                                    ])
                                                  ], -1)),
                                                  _createElementVNode("div", _hoisted_87, [
                                                    _createElementVNode("table", _hoisted_88, [
                                                      _createElementVNode("thead", null, [
                                                        _createElementVNode("tr", null, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(analysis.headers, (header, hIdx) => {
                                                            return (_openBlock(), _createElementBlock("th", {
                                                              key: hIdx,
                                                              class: _normalizeClass(quickSampleColClass(analysis, hIdx))
                                                            }, [
                                                              _createElementVNode("span", _hoisted_89, _toDisplayString(header || `컬럼${hIdx + 1}`), 1),
                                                              (quickSampleRoleLabel(analysis, hIdx))
                                                                ? (_openBlock(), _createElementBlock("em", _hoisted_90, _toDisplayString(quickSampleRoleLabel(analysis, hIdx)), 1))
                                                                : _createCommentVNode("", true)
                                                            ], 2))
                                                          }), 128))
                                                        ])
                                                      ]),
                                                      _createElementVNode("tbody", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(analysis.sampleData, (row, rIdx) => {
                                                          return (_openBlock(), _createElementBlock("tr", { key: rIdx }, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, cIdx) => {
                                                              return (_openBlock(), _createElementBlock("td", {
                                                                key: cIdx,
                                                                class: _normalizeClass(quickSampleColClass(analysis, cIdx))
                                                              }, _toDisplayString(cell), 3))
                                                            }), 128))
                                                          ]))
                                                        }), 128))
                                                      ])
                                                    ])
                                                  ])
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 2))
                              }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_91, [
                              _createElementVNode("div", _hoisted_92, [
                                (validAnalysesCount.value === 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_93, "유효한 파일이 없습니다"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_94, [
                                      _createVNode(_component_v_icon, {
                                        size: "14",
                                        color: invalidAnalysesCount.value > 0 ? '#f59e0b' : '#10b981'
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(invalidAnalysesCount.value > 0 ? 'mdi-alert' : 'mdi-check-circle'), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["color"]),
                                      _createTextVNode(" " + _toDisplayString(validAnalysesCount.value) + "개 파일 준비됨 ", 1),
                                      (invalidAnalysesCount.value > 0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_95, "(" + _toDisplayString(invalidAnalysesCount.value) + "개 오류)", 1))
                                        : _createCommentVNode("", true)
                                    ]))
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn-quick-upload",
                                disabled: validAnalysesCount.value === 0 || isQuickUploading.value,
                                onClick: processQuickUploadWithMapping
                              }, [
                                (isQuickUploading.value)
                                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                      key: 0,
                                      indeterminate: "",
                                      size: "18",
                                      width: "2",
                                      color: "white"
                                    }))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createVNode(_component_v_icon, { size: "18" }, {
                                        default: _withCtx(() => [...(_cache[118] || (_cache[118] = [
                                          _createTextVNode("mdi-upload-multiple", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _createTextVNode(" 업로드 (" + _toDisplayString(validAnalysesCount.value) + "개) ", 1)
                                    ], 64))
                              ], 8, _hoisted_96)
                            ])
                          ], 64))
                        : _createCommentVNode("", true),
                    (quickUploadComplete.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: _normalizeClass(["quick-upload-result", { 'has-error': quickUploadResult.value.errorCount > 0 }])
                        }, [
                          _createElementVNode("div", _hoisted_97, [
                            _createVNode(_component_v_icon, {
                              size: "24",
                              color: quickUploadResult.value.errorCount > 0 ? '#f59e0b' : '#10b981'
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(quickUploadResult.value.errorCount > 0 ? 'mdi-alert-circle' : 'mdi-check-circle'), 1)
                              ]),
                              _: 1
                            }, 8, ["color"]),
                            _createElementVNode("div", _hoisted_98, [
                              _createElementVNode("p", null, "업로드 " + _toDisplayString(quickUploadResult.value.errorCount > 0 ? '부분 완료' : '완료'), 1),
                              _createElementVNode("span", null, "총 " + _toDisplayString(quickUploadResult.value.totalCount) + "건 등록 (성공 " + _toDisplayString(quickUploadResult.value.successCount) + "개, 실패 " + _toDisplayString(quickUploadResult.value.errorCount) + "개)", 1)
                            ])
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn-close-result",
                            onClick: resetQuickUpload
                          }, " 확인 ")
                        ], 2))
                      : _createCommentVNode("", true)
                  ]),
                  false
                    ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                        _createElementVNode("div", _hoisted_100, [
                          _createVNode(_component_v_icon, {
                            size: "16",
                            color: "#6366f1"
                          }, {
                            default: _withCtx(() => [...(_cache[119] || (_cache[119] = [
                              _createTextVNode("mdi-school", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[120] || (_cache[120] = _createElementVNode("span", null, "적요 컬럼을 선택하고 계정을 직접 지정하여 학습시킵니다.", -1))
                        ]),
                        _createElementVNode("div", _hoisted_101, [
                          _createElementVNode("div", _hoisted_102, [
                            _createElementVNode("label", _hoisted_103, [
                              _createVNode(_component_v_icon, {
                                size: "16",
                                color: "#1565c0"
                              }, {
                                default: _withCtx(() => [...(_cache[121] || (_cache[121] = [
                                  _createTextVNode("mdi-bank", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[122] || (_cache[122] = _createTextVNode(" 통장 ", -1))
                            ]),
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((selectedUploadBankCode).value = $event)),
                              class: "bank-select-dropdown",
                              onChange: onUploadBankSelectChange
                            }, [
                              _cache[123] || (_cache[123] = _createElementVNode("option", { value: "" }, "-- 선택 --", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeBankList.value, (bank) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: bank.mb_code,
                                  value: bank.mb_code
                                }, _toDisplayString(bank.mb_alias) + " (" + _toDisplayString(bank.mb_bank_name) + ") ", 9, _hoisted_104))
                              }), 128))
                            ], 544), [
                              [_vModelSelect, selectedUploadBankCode.value]
                            ])
                          ]),
                          (selectedUploadBankLabel.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_105, [
                                _createVNode(_component_v_icon, {
                                  size: "14",
                                  color: "#1565c0"
                                }, {
                                  default: _withCtx(() => [...(_cache[124] || (_cache[124] = [
                                    _createTextVNode("mdi-information-outline", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[125] || (_cache[125] = _createTextVNode(" 선택된 통장: ", -1)),
                                _createElementVNode("strong", null, _toDisplayString(selectedUploadBankLabel.value), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_106, [
                            _createElementVNode("label", _hoisted_107, [
                              _createVNode(_component_v_icon, {
                                size: "16",
                                color: "#1565c0"
                              }, {
                                default: _withCtx(() => [...(_cache[126] || (_cache[126] = [
                                  _createTextVNode("mdi-file-excel", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[127] || (_cache[127] = _createTextVNode(" 파일 ", -1))
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["file-dropzone-inline", { 'drag-over': isDragOver.value, 'has-file': excelFile.value, 'disabled': !selectedUploadBankCode.value }]),
                              onDragover: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (isDragOver.value = true), ["prevent"])),
                              onDragleave: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (isDragOver.value = false), ["prevent"])),
                              onDrop: _withModifiers(handleDrop, ["prevent"]),
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (selectedUploadBankCode.value && triggerFileInput()))
                            }, [
                              _createElementVNode("input", {
                                ref_key: "fileInputRef",
                                ref: fileInputRef,
                                type: "file",
                                accept: ".xlsx,.xls,.csv",
                                onChange: handleFileSelect,
                                hidden: ""
                              }, null, 544),
                              (!excelFile.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_108, _toDisplayString(selectedUploadBankCode.value ? '클릭하여 파일 선택' : '먼저 통장 선택'), 1))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createVNode(_component_v_icon, {
                                      size: "18",
                                      color: "#10b981"
                                    }, {
                                      default: _withCtx(() => [...(_cache[128] || (_cache[128] = [
                                        _createTextVNode("mdi-file-excel", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _createElementVNode("span", _hoisted_109, _toDisplayString(excelFile.value.name), 1),
                                    _createElementVNode("span", _hoisted_110, "(" + _toDisplayString(formatFileSize(excelFile.value.size)) + ")", 1),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn-remove-inline",
                                      onClick: _withModifiers(removeFile, ["stop"])
                                    }, [
                                      _createVNode(_component_v_icon, { size: "14" }, {
                                        default: _withCtx(() => [...(_cache[129] || (_cache[129] = [
                                          _createTextVNode("mdi-close", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ])
                                  ], 64))
                            ], 34)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  false
                    ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn-process",
                          onClick: loadFilePreview
                        }, [
                          _createVNode(_component_v_icon, { size: "18" }, {
                            default: _withCtx(() => [...(_cache[130] || (_cache[130] = [
                              _createTextVNode("mdi-table-search", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[131] || (_cache[131] = _createTextVNode(" 헤더 행 직접 선택 ", -1))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (needHeaderSelection.value && headerPreviewData.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                        (sheetNames.value.length > 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                              _cache[132] || (_cache[132] = _createElementVNode("label", null, "시트 선택:", -1)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((selectedSheetIndex).value = $event)),
                                onChange: _cache[20] || (_cache[20] = ($event: any) => (onSheetChange(selectedSheetIndex.value)))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sheetNames.value, (name, idx) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: idx,
                                    value: idx
                                  }, _toDisplayString(name), 9, _hoisted_114))
                                }), 128))
                              ], 544), [
                                [_vModelSelect, selectedSheetIndex.value]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_115, [
                          _createVNode(_component_v_icon, {
                            size: "20",
                            color: "#1565c0"
                          }, {
                            default: _withCtx(() => [...(_cache[133] || (_cache[133] = [
                              _createTextVNode("mdi-table-row", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[134] || (_cache[134] = _createElementVNode("div", { class: "header-text" }, [
                            _createElementVNode("h4", null, "헤더 행 선택"),
                            _createElementVNode("p", null, "날짜, 금액 등 컬럼명이 있는 행을 클릭하세요.")
                          ], -1))
                        ]),
                        _createElementVNode("div", _hoisted_116, [
                          _createElementVNode("table", _hoisted_117, [
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headerPreviewData.value, (row, rowIdx) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: rowIdx,
                                  class: _normalizeClass({ 'selected-header-row': selectedHeaderRowIndex.value === rowIdx, 'clickable': true }),
                                  onClick: ($event: any) => (selectLearningHeaderRow(rowIdx))
                                }, [
                                  _createElementVNode("td", _hoisted_119, _toDisplayString(rowIdx + 1), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.slice(0, 8), (cell, cellIdx) => {
                                    return (_openBlock(), _createElementBlock("td", { key: cellIdx }, _toDisplayString(cell || '-'), 1))
                                  }), 128))
                                ], 10, _hoisted_118))
                              }), 128))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_120, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn-cancel",
                            onClick: cancelHeaderSelection
                          }, "취소"),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn-auto-detect",
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (processExcelData(false)))
                          }, [
                            _createVNode(_component_v_icon, { size: "16" }, {
                              default: _withCtx(() => [...(_cache[135] || (_cache[135] = [
                                _createTextVNode("mdi-auto-fix", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[136] || (_cache[136] = _createTextVNode(" 자동 감지 ", -1))
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn-confirm",
                            disabled: selectedHeaderRowIndex.value === null,
                            onClick: confirmHeaderSelection
                          }, [
                            _createVNode(_component_v_icon, { size: "16" }, {
                              default: _withCtx(() => [...(_cache[137] || (_cache[137] = [
                                _createTextVNode("mdi-check", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[138] || (_cache[138] = _createTextVNode(" 선택 완료 ", -1))
                          ], 8, _hoisted_121)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (needMemoSelection.value && memoSelectionData.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                        _createElementVNode("div", _hoisted_123, [
                          _createVNode(_component_v_icon, {
                            size: "20",
                            color: "#f59e0b"
                          }, {
                            default: _withCtx(() => [...(_cache[139] || (_cache[139] = [
                              _createTextVNode("mdi-alert-circle", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[142] || (_cache[142] = _createElementVNode("div", { class: "header-text" }, [
                            _createElementVNode("h4", null, "적요 컬럼 선택"),
                            _createElementVNode("p", null, "기본 컬럼을 선택하고, 특정 행만 다르게 하려면 해당 셀을 클릭하세요.")
                          ], -1)),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn-confirm-top",
                            disabled: !canConfirmMemoSelection.value,
                            onClick: showLearningStep
                          }, [
                            _createVNode(_component_v_icon, { size: "16" }, {
                              default: _withCtx(() => [...(_cache[140] || (_cache[140] = [
                                _createTextVNode("mdi-school", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[141] || (_cache[141] = _createTextVNode(" 선택 완료 후 학습하기 ", -1))
                          ], 8, _hoisted_124)
                        ]),
                        _createElementVNode("div", _hoisted_125, [
                          _cache[143] || (_cache[143] = _createElementVNode("span", { class: "column-list-label" }, "기본 컬럼:", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(memoSelectionData.value.headers, (header) => {
                            return (_openBlock(), _createElementBlock("label", {
                              key: header.index,
                              class: _normalizeClass(["memo-column-item", { selected: selectedMemoColumns.value.includes(header.index) }])
                            }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: selectedMemoColumns.value.includes(header.index),
                                onChange: ($event: any) => (toggleMemoColumn(header.index))
                              }, null, 40, _hoisted_126),
                              _createElementVNode("span", _hoisted_127, _toDisplayString(header.index + 1), 1),
                              _createElementVNode("span", _hoisted_128, _toDisplayString(header.name), 1)
                            ], 2))
                          }), 128))
                        ]),
                        (Object.keys(selectedMemoCells.value).length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                              _createVNode(_component_v_icon, {
                                size: "14",
                                color: "#f59e0b"
                              }, {
                                default: _withCtx(() => [...(_cache[144] || (_cache[144] = [
                                  _createTextVNode("mdi-alert", -1)
                                ]))]),
                                _: 1
                              }),
                              _createElementVNode("span", null, _toDisplayString(Object.keys(selectedMemoCells.value).length) + "개 행이 개별 설정됨", 1),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn-reset-override",
                                onClick: resetCellSelection
                              }, " 초기화 ")
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_130, [
                          _createElementVNode("div", _hoisted_131, [
                            _createVNode(_component_v_icon, {
                              size: "14",
                              color: "#6366f1"
                            }, {
                              default: _withCtx(() => [...(_cache[145] || (_cache[145] = [
                                _createTextVNode("mdi-eye", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[146] || (_cache[146] = _createElementVNode("span", null, "데이터 미리보기", -1)),
                            _cache[147] || (_cache[147] = _createElementVNode("span", { class: "selected-hint" }, "(셀 클릭으로 개별 행 설정 가능)", -1))
                          ]),
                          _createElementVNode("div", _hoisted_132, [
                            _createElementVNode("table", _hoisted_133, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _cache[148] || (_cache[148] = _createElementVNode("th", { class: "th-row-num" }, "#", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(memoSelectionData.value.headers, (header) => {
                                    return (_openBlock(), _createElementBlock("th", {
                                      key: header.index,
                                      class: _normalizeClass({ selected: selectedMemoColumns.value.includes(header.index), clickable: true }),
                                      onClick: ($event: any) => (toggleMemoColumn(header.index))
                                    }, _toDisplayString(header.name), 11, _hoisted_134))
                                  }), 128)),
                                  _cache[149] || (_cache[149] = _createElementVNode("th", { class: "th-memo-result" }, "적요 결과", -1))
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(memoSelectionData.value.sampleData, (row, rowIdx) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: rowIdx,
                                    class: _normalizeClass({ 'row-overridden': hasRowOverride(rowIdx) })
                                  }, [
                                    _createElementVNode("td", _hoisted_135, [
                                      _createTextVNode(_toDisplayString(rowIdx + 1) + " ", 1),
                                      (hasRowOverride(rowIdx))
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 0,
                                            size: "10",
                                            color: "#f59e0b"
                                          }, {
                                            default: _withCtx(() => [...(_cache[150] || (_cache[150] = [
                                              _createTextVNode("mdi-pencil", -1)
                                            ]))]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(memoSelectionData.value.headers, (header) => {
                                      return (_openBlock(), _createElementBlock("td", {
                                        key: header.index,
                                        class: _normalizeClass({ selected: isCellSelected(rowIdx, header.index) }),
                                        onClick: ($event: any) => (toggleCellSelection(rowIdx, header.index))
                                      }, _toDisplayString(row[header.index] || '-'), 11, _hoisted_136))
                                    }), 128)),
                                    _createElementVNode("td", _hoisted_137, _toDisplayString(getCellMemoResult(rowIdx, row)), 1)
                                  ], 2))
                                }), 128))
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_138, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn-cancel",
                            onClick: cancelMemoSelection
                          }, "취소"),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn-confirm",
                            disabled: !canConfirmMemoSelection.value,
                            onClick: showLearningStep
                          }, [
                            _createVNode(_component_v_icon, { size: "16" }, {
                              default: _withCtx(() => [...(_cache[151] || (_cache[151] = [
                                _createTextVNode("mdi-school", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[152] || (_cache[152] = _createTextVNode(" 선택 완료 후 학습하기 ", -1))
                          ], 8, _hoisted_139)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (isProcessing.value || processComplete.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                        _createElementVNode("div", _hoisted_141, [
                          _createVNode(_component_v_icon, {
                            size: "18",
                            color: processComplete.value ? '#10b981' : '#6366f1'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(processComplete.value ? 'mdi-check-circle' : 'mdi-loading mdi-spin'), 1)
                            ]),
                            _: 1
                          }, 8, ["color"]),
                          _createElementVNode("span", null, _toDisplayString(processStatus.value.message), 1)
                        ]),
                        ((processStatus.value.total ?? 0) > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                              _createElementVNode("div", _hoisted_143, [
                                _createElementVNode("div", {
                                  class: "progress-fill",
                                  style: _normalizeStyle({ width: `${((processStatus.value.current || 0) / (processStatus.value.total || 1)) * 100}%` })
                                }, null, 4)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (processComplete.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                              _createElementVNode("div", _hoisted_145, [
                                _createElementVNode("div", _hoisted_146, [
                                  _createVNode(_component_v_icon, {
                                    size: "16",
                                    color: "#10b981"
                                  }, {
                                    default: _withCtx(() => [...(_cache[153] || (_cache[153] = [
                                      _createTextVNode("mdi-plus-circle", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createElementVNode("span", null, "수입 " + _toDisplayString(processResult.value.incomeCount) + "건", 1),
                                  _createElementVNode("span", _hoisted_147, _toDisplayString(formatNumber(processResult.value.incomeTotal)) + "원", 1)
                                ]),
                                _createElementVNode("div", _hoisted_148, [
                                  _createVNode(_component_v_icon, {
                                    size: "16",
                                    color: "#f97316"
                                  }, {
                                    default: _withCtx(() => [...(_cache[154] || (_cache[154] = [
                                      _createTextVNode("mdi-minus-circle", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createElementVNode("span", null, "지출 " + _toDisplayString(processResult.value.expenseCount) + "건", 1),
                                  _createElementVNode("span", _hoisted_149, _toDisplayString(formatNumber(processResult.value.expenseTotal)) + "원", 1)
                                ])
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn-close-result",
                                onClick: closeDialog
                              }, [
                                _createVNode(_component_v_icon, { size: "16" }, {
                                  default: _withCtx(() => [...(_cache[155] || (_cache[155] = [
                                    _createTextVNode("mdi-check", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[156] || (_cache[156] = _createTextVNode(" 완료 ", -1))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
          ])
        ], 512), [
          [_vShow, activeTab.value === 'excel']
        ]),
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
              _createElementVNode("div", _hoisted_151, [
                _createElementVNode("div", _hoisted_152, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-back",
                    onClick: backToMemoSelection
                  }, [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[157] || (_cache[157] = [
                        _createTextVNode("mdi-arrow-left", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[158] || (_cache[158] = _createTextVNode(" 이전 ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_153, [
                    _createVNode(_component_v_icon, { size: "14" }, {
                      default: _withCtx(() => [...(_cache[159] || (_cache[159] = [
                        _createTextVNode("mdi-file-excel", -1)
                      ]))]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(excelFile.value?.name), 1)
                  ])
                ]),
                _cache[162] || (_cache[162] = _createElementVNode("div", { class: "toolbar-center" }, [
                  _createElementVNode("span", { class: "learning-hint" }, "적요별로 계정을 지정하세요")
                ], -1)),
                _createElementVNode("div", _hoisted_154, [
                  _createElementVNode("div", _hoisted_155, [
                    _createElementVNode("span", _hoisted_156, _toDisplayString(learnedGroupCount.value), 1),
                    _cache[160] || (_cache[160] = _createElementVNode("span", { class: "divider" }, "/", -1)),
                    _createElementVNode("span", _hoisted_157, _toDisplayString(memoGroups.value.length), 1),
                    _cache[161] || (_cache[161] = _createElementVNode("span", { class: "label" }, "학습됨", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_158, [
                _createElementVNode("div", _hoisted_159, [
                  _createElementVNode("div", _hoisted_160, [
                    _cache[164] || (_cache[164] = _createElementVNode("h4", null, "적요 그룹", -1)),
                    _createElementVNode("div", _hoisted_161, [
                      _createElementVNode("div", _hoisted_162, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((groupSortField).value = $event)),
                          class: "sort-select"
                        }, [...(_cache[163] || (_cache[163] = [
                          _createElementVNode("option", { value: "date" }, "날짜순", -1),
                          _createElementVNode("option", { value: "amount" }, "금액순", -1)
                        ]))], 512), [
                          [_vModelSelect, groupSortField.value]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "sort-order-btn",
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (groupSortOrder.value = groupSortOrder.value === 'asc' ? 'desc' : 'asc')),
                          title: groupSortOrder.value === 'asc' ? '오름차순' : '내림차순'
                        }, [
                          _createVNode(_component_v_icon, { size: "14" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(groupSortOrder.value === 'asc' ? 'mdi-sort-ascending' : 'mdi-sort-descending'), 1)
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_163)
                      ]),
                      _createElementVNode("div", _hoisted_164, [
                        _createElementVNode("button", {
                          class: _normalizeClass({ active: groupFilter.value === 'all' }),
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (groupFilter.value = 'all'))
                        }, "전체", 2),
                        _createElementVNode("button", {
                          class: _normalizeClass({ active: groupFilter.value === 'unlearned' }),
                          onClick: _cache[25] || (_cache[25] = ($event: any) => (groupFilter.value = 'unlearned'))
                        }, "미학습", 2),
                        _createElementVNode("button", {
                          class: _normalizeClass({ active: groupFilter.value === 'learned' }),
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (groupFilter.value = 'learned'))
                        }, "학습됨", 2)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_165, [
                    _createElementVNode("div", _hoisted_166, [
                      _createVNode(_component_v_icon, {
                        size: "16",
                        color: "#94a3b8"
                      }, {
                        default: _withCtx(() => [...(_cache[165] || (_cache[165] = [
                          _createTextVNode("mdi-magnify", -1)
                        ]))]),
                        _: 1
                      }),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((groupSearchQuery).value = $event)),
                        placeholder: "적요 검색 (예: 급여, 회식)",
                        class: "search-input",
                        onKeyup: _withKeys(applyGroupSearch, ["enter"])
                      }, null, 544), [
                        [_vModelText, groupSearchQuery.value]
                      ]),
                      (groupSearchQuery.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "search-clear-btn",
                            onClick: clearGroupSearch
                          }, [
                            _createVNode(_component_v_icon, { size: "14" }, {
                              default: _withCtx(() => [...(_cache[166] || (_cache[166] = [
                                _createTextVNode("mdi-close", -1)
                              ]))]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (searchResultGroups.value.length > 0 && groupSearchQuery.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                          _createElementVNode("div", _hoisted_168, [
                            _createVNode(_component_v_icon, {
                              size: "14",
                              color: "#6366f1"
                            }, {
                              default: _withCtx(() => [...(_cache[167] || (_cache[167] = [
                                _createTextVNode("mdi-filter-variant", -1)
                              ]))]),
                              _: 1
                            }),
                            _createElementVNode("span", null, [
                              _createElementVNode("strong", null, _toDisplayString(searchResultGroups.value.length), 1),
                              _cache[168] || (_cache[168] = _createTextVNode("개 그룹 검색됨", -1))
                            ])
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn-bulk-assign",
                            onClick: openBulkAssignModal,
                            disabled: searchResultGroups.value.length === 0
                          }, [
                            _createVNode(_component_v_icon, { size: "14" }, {
                              default: _withCtx(() => [...(_cache[169] || (_cache[169] = [
                                _createTextVNode("mdi-tag-multiple", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[170] || (_cache[170] = _createTextVNode(" 일괄 계정 지정 ", -1))
                          ], 8, _hoisted_169)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_170, [
                      _createElementVNode("label", _hoisted_171, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((isMultiSelectMode).value = $event)),
                          onChange: onMultiSelectModeChange
                        }, null, 544), [
                          [_vModelCheckbox, isMultiSelectMode.value]
                        ]),
                        _cache[171] || (_cache[171] = _createElementVNode("span", null, "다중 선택", -1))
                      ]),
                      (isMultiSelectMode.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (selectedGroupIndices.value.size > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_172, _toDisplayString(selectedGroupIndices.value.size) + "개 선택됨 ", 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn-bulk-assign-selected",
                              onClick: openBulkAssignSelectedModal,
                              disabled: selectedGroupIndices.value.size === 0
                            }, [
                              _createVNode(_component_v_icon, { size: "14" }, {
                                default: _withCtx(() => [...(_cache[172] || (_cache[172] = [
                                  _createTextVNode("mdi-tag-multiple", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[173] || (_cache[173] = _createTextVNode(" 선택 항목 계정 지정 ", -1))
                            ], 8, _hoisted_173),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn-select-all",
                              onClick: toggleSelectAll
                            }, _toDisplayString(isAllDisplayedSelected.value ? '전체 해제' : '전체 선택'), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_174, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedGroups.value, (group, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: group.keyword + '-' + group.gubun,
                        class: _normalizeClass(["group-card", { 
                  selected: selectedGroupIdx.value === getOriginalIndex(group),
                  learned: group.learned || group.selectedScode,
                  income: group.gubun === 'IN',
                  expense: group.gubun === 'OUT',
                  'search-match': groupSearchQuery.value && isSearchMatch(group),
                  'multi-selected': isMultiSelectMode.value && selectedGroupIndices.value.has(getOriginalIndex(group)),
                  'multi-select-mode': isMultiSelectMode.value
                }]),
                        onClick: ($event: any) => (onGroupCardClick(group, $event))
                      }, [
                        (isMultiSelectMode.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "card-checkbox",
                              onClick: _cache[29] || (_cache[29] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: selectedGroupIndices.value.has(getOriginalIndex(group)),
                                onChange: ($event: any) => (toggleGroupSelection(getOriginalIndex(group)))
                              }, null, 40, _hoisted_176)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_177, [
                          _createElementVNode("div", _hoisted_178, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["gubun-badge", group.gubun])
                            }, _toDisplayString(group.gubun === 'IN' ? '수입' : '지출'), 3),
                            (getGroupDateDisplay(group))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_179, _toDisplayString(getGroupDateDisplay(group)), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_180, _toDisplayString(group.count) + "건", 1),
                            _createElementVNode("span", _hoisted_181, _toDisplayString(formatNumber(group.totalPrice)) + "원", 1)
                          ]),
                          _createElementVNode("div", _hoisted_182, _toDisplayString(group.keyword), 1),
                          _createElementVNode("div", _hoisted_183, [
                            (group.learned || group.selectedScode)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createVNode(_component_v_icon, {
                                    size: "12",
                                    color: "#10b981"
                                  }, {
                                    default: _withCtx(() => [...(_cache[174] || (_cache[174] = [
                                      _createTextVNode("mdi-check-circle", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createElementVNode("span", _hoisted_184, _toDisplayString(getScodeNameForGroup(group)), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock("span", _hoisted_185, "계정 미지정"))
                          ])
                        ])
                      ], 10, _hoisted_175))
                    }), 128)),
                    (displayedGroups.value.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                          _createVNode(_component_v_icon, {
                            size: "40",
                            color: "#cbd5e1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(groupSearchQuery.value ? 'mdi-magnify-close' : 'mdi-check-all'), 1)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("p", null, _toDisplayString(getEmptyStateMessage.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(_component_v_dialog, {
                  modelValue: showBulkAssignModal.value,
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((showBulkAssignModal).value = $event)),
                  "max-width": "500"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_187, [
                      _createElementVNode("div", _hoisted_188, [
                        _createVNode(_component_v_icon, {
                          size: "24",
                          color: "#6366f1"
                        }, {
                          default: _withCtx(() => [...(_cache[175] || (_cache[175] = [
                            _createTextVNode("mdi-tag-multiple", -1)
                          ]))]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_189, [
                          _cache[176] || (_cache[176] = _createElementVNode("h3", null, "일괄 계정 지정", -1)),
                          _createElementVNode("p", null, "\"" + _toDisplayString(groupSearchQuery.value) + "\" 검색 결과 " + _toDisplayString(searchResultGroups.value.length) + "개 그룹", 1)
                        ]),
                        _createElementVNode("button", {
                          class: "close-btn",
                          onClick: _cache[30] || (_cache[30] = ($event: any) => (showBulkAssignModal.value = false))
                        }, [
                          _createVNode(_component_v_icon, { size: "20" }, {
                            default: _withCtx(() => [...(_cache[177] || (_cache[177] = [
                              _createTextVNode("mdi-close", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_190, [
                        _createElementVNode("div", _hoisted_191, [
                          _createElementVNode("div", _hoisted_192, [
                            _cache[178] || (_cache[178] = _createElementVNode("span", null, "포함된 적요 그룹", -1)),
                            _createElementVNode("span", _hoisted_193, _toDisplayString(searchResultGroups.value.length) + "개", 1)
                          ]),
                          _createElementVNode("div", _hoisted_194, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResultGroups.value.slice(0, 5), (group, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: idx,
                                class: _normalizeClass(["preview-item", group.gubun])
                              }, [
                                _createElementVNode("span", _hoisted_195, _toDisplayString(group.gubun === 'IN' ? '수입' : '지출'), 1),
                                _createElementVNode("span", _hoisted_196, _toDisplayString(group.keyword), 1),
                                _createElementVNode("span", _hoisted_197, _toDisplayString(group.count) + "건", 1)
                              ], 2))
                            }), 128)),
                            (searchResultGroups.value.length > 5)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_198, " ... 외 " + _toDisplayString(searchResultGroups.value.length - 5) + "개 ", 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_199, [
                          _cache[179] || (_cache[179] = _createElementVNode("label", null, "적용 대상", -1)),
                          _createElementVNode("div", _hoisted_200, [
                            _createElementVNode("label", {
                              class: _normalizeClass(["gubun-option", { active: bulkAssignGubun.value === 'all' }])
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((bulkAssignGubun).value = $event)),
                                value: "all"
                              }, null, 512), [
                                [_vModelRadio, bulkAssignGubun.value]
                              ]),
                              _createElementVNode("span", null, "전체 (" + _toDisplayString(searchResultGroups.value.length) + ")", 1)
                            ], 2),
                            _createElementVNode("label", {
                              class: _normalizeClass(["gubun-option income", { active: bulkAssignGubun.value === 'IN' }])
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((bulkAssignGubun).value = $event)),
                                value: "IN"
                              }, null, 512), [
                                [_vModelRadio, bulkAssignGubun.value]
                              ]),
                              _createElementVNode("span", null, "수입만 (" + _toDisplayString(searchResultGroups.value.filter(g => g.gubun === 'IN').length) + ")", 1)
                            ], 2),
                            _createElementVNode("label", {
                              class: _normalizeClass(["gubun-option expense", { active: bulkAssignGubun.value === 'OUT' }])
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((bulkAssignGubun).value = $event)),
                                value: "OUT"
                              }, null, 512), [
                                [_vModelRadio, bulkAssignGubun.value]
                              ]),
                              _createElementVNode("span", null, "지출만 (" + _toDisplayString(searchResultGroups.value.filter(g => g.gubun === 'OUT').length) + ")", 1)
                            ], 2)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_201, [
                          _cache[180] || (_cache[180] = _createElementVNode("label", null, "지정할 계정", -1)),
                          _createVNode(_component_v_autocomplete, {
                            modelValue: bulkAssignScode.value,
                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((bulkAssignScode).value = $event)),
                            items: bulkAssignGubun.value === 'IN' ? incomeCodeList.value : (bulkAssignGubun.value === 'OUT' ? expenseCodeList.value : [...incomeCodeList.value, ...expenseCodeList.value]),
                            "item-title": "sname",
                            "item-value": "scode",
                            variant: "outlined",
                            density: "comfortable",
                            "hide-details": "",
                            placeholder: "계정을 선택하세요",
                            class: "account-autocomplete"
                          }, null, 8, ["modelValue", "items"])
                        ]),
                        _createElementVNode("div", _hoisted_202, [
                          _createElementVNode("label", _hoisted_203, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((bulkRegisterAsKeyword).value = $event))
                            }, null, 512), [
                              [_vModelCheckbox, bulkRegisterAsKeyword.value]
                            ]),
                            _createElementVNode("span", null, "검색어 \"" + _toDisplayString(groupSearchQuery.value) + "\"를 키워드로도 등록", 1)
                          ]),
                          _createElementVNode("p", _hoisted_204, "체크하면 다음 업로드 시 \"" + _toDisplayString(groupSearchQuery.value) + "\"가 포함된 적요에 자동으로 이 계정이 추천됩니다.", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_205, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn-cancel",
                          onClick: _cache[36] || (_cache[36] = ($event: any) => (showBulkAssignModal.value = false))
                        }, "취소"),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn-apply",
                          disabled: !bulkAssignScode.value,
                          onClick: applyBulkAssign
                        }, [
                          _createVNode(_component_v_icon, { size: "16" }, {
                            default: _withCtx(() => [...(_cache[181] || (_cache[181] = [
                              _createTextVNode("mdi-check", -1)
                            ]))]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(getBulkApplyCount.value) + "개 그룹에 적용 ", 1)
                        ], 8, _hoisted_206)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_dialog, {
                  modelValue: showBulkAssignSelectedModal.value,
                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((showBulkAssignSelectedModal).value = $event)),
                  "max-width": "500"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_207, [
                      _createElementVNode("div", _hoisted_208, [
                        _createVNode(_component_v_icon, {
                          size: "24",
                          color: "#6366f1"
                        }, {
                          default: _withCtx(() => [...(_cache[182] || (_cache[182] = [
                            _createTextVNode("mdi-tag-multiple", -1)
                          ]))]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_209, [
                          _cache[183] || (_cache[183] = _createElementVNode("h3", null, "선택 항목 계정 지정", -1)),
                          _createElementVNode("p", null, _toDisplayString(selectedGroupIndices.value.size) + "개 그룹 선택됨", 1)
                        ]),
                        _createElementVNode("button", {
                          class: "close-btn",
                          onClick: _cache[38] || (_cache[38] = ($event: any) => (showBulkAssignSelectedModal.value = false))
                        }, [
                          _createVNode(_component_v_icon, { size: "20" }, {
                            default: _withCtx(() => [...(_cache[184] || (_cache[184] = [
                              _createTextVNode("mdi-close", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_210, [
                        _createElementVNode("div", _hoisted_211, [
                          _createElementVNode("div", _hoisted_212, [
                            _cache[185] || (_cache[185] = _createElementVNode("span", null, "선택된 적요 그룹", -1)),
                            _createElementVNode("span", _hoisted_213, _toDisplayString(selectedGroupIndices.value.size) + "개", 1)
                          ]),
                          _createElementVNode("div", _hoisted_214, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedGroupsForBulk.value.slice(0, 5), (group, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: idx,
                                class: _normalizeClass(["preview-item", group.gubun])
                              }, [
                                _createElementVNode("span", _hoisted_215, _toDisplayString(group.gubun === 'IN' ? '수입' : '지출'), 1),
                                _createElementVNode("span", _hoisted_216, _toDisplayString(group.keyword), 1)
                              ], 2))
                            }), 128)),
                            (selectedGroupsForBulk.value.length > 5)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_217, " ... 외 " + _toDisplayString(selectedGroupsForBulk.value.length - 5) + "개 ", 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_218, [
                          _cache[186] || (_cache[186] = _createElementVNode("label", null, "적용 대상", -1)),
                          _createElementVNode("div", _hoisted_219, [
                            _createElementVNode("label", {
                              class: _normalizeClass(["gubun-option", { active: bulkSelectedGubun.value === 'all' }])
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((bulkSelectedGubun).value = $event)),
                                value: "all"
                              }, null, 512), [
                                [_vModelRadio, bulkSelectedGubun.value]
                              ]),
                              _createElementVNode("span", null, "전체 (" + _toDisplayString(selectedGroupsForBulk.value.length) + ")", 1)
                            ], 2),
                            _createElementVNode("label", {
                              class: _normalizeClass(["gubun-option income", { active: bulkSelectedGubun.value === 'IN' }])
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((bulkSelectedGubun).value = $event)),
                                value: "IN"
                              }, null, 512), [
                                [_vModelRadio, bulkSelectedGubun.value]
                              ]),
                              _createElementVNode("span", null, "수입만 (" + _toDisplayString(selectedGroupsForBulk.value.filter(g => g.gubun === 'IN').length) + ")", 1)
                            ], 2),
                            _createElementVNode("label", {
                              class: _normalizeClass(["gubun-option expense", { active: bulkSelectedGubun.value === 'OUT' }])
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((bulkSelectedGubun).value = $event)),
                                value: "OUT"
                              }, null, 512), [
                                [_vModelRadio, bulkSelectedGubun.value]
                              ]),
                              _createElementVNode("span", null, "지출만 (" + _toDisplayString(selectedGroupsForBulk.value.filter(g => g.gubun === 'OUT').length) + ")", 1)
                            ], 2)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_220, [
                          _cache[187] || (_cache[187] = _createElementVNode("label", null, "지정할 계정", -1)),
                          _createVNode(_component_v_autocomplete, {
                            modelValue: bulkSelectedScode.value,
                            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((bulkSelectedScode).value = $event)),
                            items: bulkSelectedGubun.value === 'IN' ? incomeCodeList.value : (bulkSelectedGubun.value === 'OUT' ? expenseCodeList.value : [...incomeCodeList.value, ...expenseCodeList.value]),
                            "item-title": "sname",
                            "item-value": "scode",
                            variant: "outlined",
                            density: "comfortable",
                            "hide-details": "",
                            placeholder: "계정을 선택하세요",
                            class: "account-autocomplete"
                          }, null, 8, ["modelValue", "items"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_221, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn-cancel",
                          onClick: _cache[43] || (_cache[43] = ($event: any) => (showBulkAssignSelectedModal.value = false))
                        }, "취소"),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn-apply",
                          disabled: !bulkSelectedScode.value,
                          onClick: applyBulkAssignSelected
                        }, [
                          _createVNode(_component_v_icon, { size: "16" }, {
                            default: _withCtx(() => [...(_cache[188] || (_cache[188] = [
                              _createTextVNode("mdi-check", -1)
                            ]))]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(getBulkSelectedApplyCount.value) + "개 그룹에 적용 ", 1)
                        ], 8, _hoisted_222)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_223, [
                  (selectedGroup.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_224, [
                          _createElementVNode("div", _hoisted_225, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["gubun-tag", selectedGroup.value.gubun])
                            }, _toDisplayString(selectedGroup.value.gubun === 'IN' ? '수입' : '지출'), 3),
                            _createElementVNode("h3", null, _toDisplayString(selectedGroup.value.keyword), 1)
                          ]),
                          _createElementVNode("div", _hoisted_226, [
                            _createElementVNode("span", null, _toDisplayString(selectedGroup.value.count) + "건", 1),
                            _createElementVNode("span", null, "총 " + _toDisplayString(formatNumber(selectedGroup.value.totalPrice)) + "원", 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_227, [
                          _cache[190] || (_cache[190] = _createElementVNode("label", null, "계정 선택", -1)),
                          _createVNode(_component_v_autocomplete, {
                            modelValue: selectedGroup.value.selectedScode,
                            "onUpdate:modelValue": [
                              _cache[45] || (_cache[45] = ($event: any) => ((selectedGroup.value.selectedScode) = $event)),
                              _cache[46] || (_cache[46] = ($event: any) => (selectedGroupIdx.value !== null && onScodeSelect(selectedGroupIdx.value)))
                            ],
                            items: selectedGroup.value.gubun === 'IN' ? incomeCodeList.value : expenseCodeList.value,
                            "item-title": "sname",
                            "item-value": "scode",
                            variant: "outlined",
                            density: "comfortable",
                            "hide-details": "",
                            placeholder: "계정을 선택하세요",
                            class: "account-autocomplete"
                          }, null, 8, ["modelValue", "items"]),
                          (selectedGroup.value.learned)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_228, [
                                _createVNode(_component_v_icon, {
                                  size: "14",
                                  color: "#10b981"
                                }, {
                                  default: _withCtx(() => [...(_cache[189] || (_cache[189] = [
                                    _createTextVNode("mdi-school", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createElementVNode("span", null, _toDisplayString(getLearningSourceLabel(selectedGroup.value.learned.source)) + "에서 학습됨", 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_229, [
                          _createElementVNode("div", _hoisted_230, [
                            _createElementVNode("h4", null, "포함된 적요 (" + _toDisplayString(selectedGroup.value.memos.length) + "건)", 1)
                          ]),
                          _createElementVNode("div", _hoisted_231, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedSelectedMemos.value, (memo, mCode) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: mCode,
                                class: "memo-item"
                              }, [
                                (memo.date)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_232, _toDisplayString(formatMemoDate(memo.date)), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", _hoisted_233, _toDisplayString(memo.memo), 1),
                                _createElementVNode("span", _hoisted_234, _toDisplayString(formatNumber(memo.price)) + "원", 1)
                              ]))
                            }), 128))
                          ])
                        ]),
                        (registeredKeywords.value.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_235, [
                              _createElementVNode("div", _hoisted_236, [
                                _createElementVNode("h4", null, [
                                  _createVNode(_component_v_icon, { size: "16" }, {
                                    default: _withCtx(() => [...(_cache[191] || (_cache[191] = [
                                      _createTextVNode("mdi-tag-multiple", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _cache[192] || (_cache[192] = _createTextVNode(" 이번에 등록할 키워드 ", -1))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_237, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(registeredKeywords.value, (rk, rkIdx) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: rkIdx,
                                    class: "registered-item"
                                  }, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["rk-gubun", rk.gubun])
                                    }, _toDisplayString(rk.gubun === 'IN' ? '수입' : '지출'), 3),
                                    _createElementVNode("span", _hoisted_238, _toDisplayString(rk.keyword), 1),
                                    _createVNode(_component_v_icon, {
                                      size: "12",
                                      color: "#94a3b8"
                                    }, {
                                      default: _withCtx(() => [...(_cache[193] || (_cache[193] = [
                                        _createTextVNode("mdi-arrow-right", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _createElementVNode("span", _hoisted_239, _toDisplayString(rk.scodeName), 1),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "rk-remove",
                                      onClick: ($event: any) => (removeRegisteredKeyword(rkIdx))
                                    }, [
                                      _createVNode(_component_v_icon, { size: "12" }, {
                                        default: _withCtx(() => [...(_cache[194] || (_cache[194] = [
                                          _createTextVNode("mdi-close", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ], 8, _hoisted_240)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_241, [
                        _createVNode(_component_v_icon, {
                          size: "60",
                          color: "#e2e8f0"
                        }, {
                          default: _withCtx(() => [...(_cache[195] || (_cache[195] = [
                            _createTextVNode("mdi-gesture-tap", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[196] || (_cache[196] = _createElementVNode("p", null, "좌측에서 적요 그룹을 선택하세요", -1))
                      ]))
                ])
              ]),
              _createElementVNode("div", _hoisted_242, [
                _createElementVNode("div", _hoisted_243, [
                  _createVNode(_component_v_icon, {
                    size: "16",
                    color: "#6366f1"
                  }, {
                    default: _withCtx(() => [...(_cache[197] || (_cache[197] = [
                      _createTextVNode("mdi-information", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[198] || (_cache[198] = _createElementVNode("span", null, "학습된 키워드는 다음 업로드 시 자동으로 계정이 추론됩니다.", -1))
                ]),
                _createElementVNode("div", _hoisted_244, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-skip",
                    onClick: _cache[47] || (_cache[47] = ($event: any) => (showConfirmDialog('skip')))
                  }, " 학습 없이 등록만 "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-save-register",
                    disabled: isProcessing.value,
                    onClick: _cache[48] || (_cache[48] = ($event: any) => (showConfirmDialog('saveAndRegister')))
                  }, [
                    (isProcessing.value)
                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                          key: 0,
                          indeterminate: "",
                          size: "18",
                          width: "2",
                          color: "white"
                        }))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_v_icon, { size: "18" }, {
                            default: _withCtx(() => [...(_cache[199] || (_cache[199] = [
                              _createTextVNode("mdi-check-all", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[200] || (_cache[200] = _createTextVNode(" 학습 저장 및 등록 ", -1))
                        ], 64))
                  ], 8, _hoisted_245)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_dialog, {
          modelValue: confirmDialogOpen.value,
          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((confirmDialogOpen).value = $event)),
          "max-width": "420",
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_246, [
              _createElementVNode("div", _hoisted_247, [
                _createElementVNode("span", null, _toDisplayString(confirmDialogType.value === 'skip' ? '학습 없이 등록' : '학습 저장 및 등록'), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "confirm-dialog__close",
                  disabled: isProcessing.value,
                  "aria-label": "닫기",
                  onClick: _cache[49] || (_cache[49] = ($event: any) => (confirmDialogOpen.value = false))
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[201] || (_cache[201] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ], 8, _hoisted_248)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["confirm-icon", confirmDialogType.value])
              }, [
                _createVNode(_component_v_icon, {
                  size: "32",
                  color: confirmDialogType.value === 'skip' ? '#f59e0b' : '#6366f1'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(confirmDialogType.value === 'skip' ? 'mdi-alert-circle' : 'mdi-school'), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ], 2),
              _createElementVNode("div", _hoisted_249, [
                _createElementVNode("h3", null, _toDisplayString(confirmDialogType.value === 'skip' ? '학습 없이 등록하시겠습니까?' : '학습 저장 및 등록하시겠습니까?'), 1),
                (confirmDialogType.value === 'skip')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_250, [...(_cache[202] || (_cache[202] = [
                      _createTextVNode(" 적요 그룹에 지정한 계정은 저장되지 않습니다.", -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" 다음 업로드 시 다시 계정을 지정해야 합니다. ", -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_251, [
                      _createElementVNode("strong", null, _toDisplayString(learnedGroupCount.value) + "개 그룹", 1),
                      _cache[205] || (_cache[205] = _createTextVNode("의 계정 정보가 학습됩니다.", -1)),
                      _cache[206] || (_cache[206] = _createElementVNode("br", null, null, -1)),
                      (registeredKeywords.value.length > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("strong", null, _toDisplayString(registeredKeywords.value.length) + "개 키워드", 1),
                            _cache[203] || (_cache[203] = _createTextVNode("가 새로 등록됩니다.", -1)),
                            _cache[204] || (_cache[204] = _createElementVNode("br", null, null, -1))
                          ], 64))
                        : _createCommentVNode("", true),
                      _cache[207] || (_cache[207] = _createTextVNode(" 다음 업로드 시 자동으로 계정이 추론됩니다. ", -1))
                    ]))
              ]),
              (confirmDialogType.value === 'saveAndRegister')
                ? (_openBlock(), _createElementBlock("div", _hoisted_252, [
                    _createElementVNode("div", _hoisted_253, [
                      _createVNode(_component_v_icon, {
                        size: "16",
                        color: "#10b981"
                      }, {
                        default: _withCtx(() => [...(_cache[208] || (_cache[208] = [
                          _createTextVNode("mdi-check-circle", -1)
                        ]))]),
                        _: 1
                      }),
                      _createElementVNode("span", null, "학습된 그룹: " + _toDisplayString(learnedGroupCount.value) + "개", 1)
                    ]),
                    (registeredKeywords.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_254, [
                          _createVNode(_component_v_icon, {
                            size: "16",
                            color: "#f59e0b"
                          }, {
                            default: _withCtx(() => [...(_cache[209] || (_cache[209] = [
                              _createTextVNode("mdi-tag-multiple", -1)
                            ]))]),
                            _: 1
                          }),
                          _createElementVNode("span", null, "등록할 키워드: " + _toDisplayString(registeredKeywords.value.length) + "개", 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_255, [
                      _createVNode(_component_v_icon, {
                        size: "16",
                        color: "#6366f1"
                      }, {
                        default: _withCtx(() => [...(_cache[210] || (_cache[210] = [
                          _createTextVNode("mdi-file-document", -1)
                        ]))]),
                        _: 1
                      }),
                      _createElementVNode("span", null, "등록할 데이터: " + _toDisplayString(getTotalMemoCount.value) + "건", 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_256, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-cancel",
                  onClick: _cache[50] || (_cache[50] = ($event: any) => (confirmDialogOpen.value = false))
                }, " 취소 "),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn-confirm", confirmDialogType.value]),
                  onClick: executeConfirmedAction
                }, [
                  _createVNode(_component_v_icon, { size: "16" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(confirmDialogType.value === 'skip' ? 'mdi-check' : 'mdi-school'), 1)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(confirmDialogType.value === 'skip' ? '등록만 진행' : '학습 및 등록'), 1)
                ], 2)
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (activeTab.value === 'input')
          ? (_openBlock(), _createElementBlock("div", _hoisted_257, [
              _createElementVNode("button", {
                type: "button",
                class: "btn-cancel",
                onClick: closeDialog
              }, "취소"),
              _createElementVNode("button", {
                type: "button",
                class: "btn-save",
                onClick: saveManualInput,
                disabled: !canSave.value || isSaving.value
              }, [
                (isSaving.value)
                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                      key: 0,
                      indeterminate: "",
                      size: "18",
                      width: "2",
                      color: "white"
                    }))
                  : (_openBlock(), _createElementBlock("span", _hoisted_259, "저장"))
              ], 8, _hoisted_258)
            ]))
          : _createCommentVNode("", true)
      ], 2),
      _createVNode(_component_v_dialog, {
        modelValue: showHelpDialog.value,
        "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((showHelpDialog).value = $event)),
        "max-width": "700"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_260, [
            _createElementVNode("div", _hoisted_261, [
              _createVNode(_component_v_icon, {
                size: "24",
                color: "#6366f1"
              }, {
                default: _withCtx(() => [...(_cache[211] || (_cache[211] = [
                  _createTextVNode("mdi-book-open-variant", -1)
                ]))]),
                _: 1
              }),
              _cache[213] || (_cache[213] = _createElementVNode("h3", null, "통장내역 업로드 사용 설명서", -1)),
              _createElementVNode("button", {
                class: "close-btn",
                onClick: _cache[52] || (_cache[52] = ($event: any) => (showHelpDialog.value = false))
              }, [
                _createVNode(_component_v_icon, { size: "20" }, {
                  default: _withCtx(() => [...(_cache[212] || (_cache[212] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_262, [
              _cache[217] || (_cache[217] = _createElementVNode("div", { class: "help-section" }, [
                _createElementVNode("div", { class: "section-title" }, [
                  _createElementVNode("span", { class: "step-badge" }, "1"),
                  _createElementVNode("h4", null, "엑셀 업로드")
                ]),
                _createElementVNode("div", { class: "section-body" }, [
                  _createElementVNode("p", null, "통장별로 은행에서 받은 거래내역 파일(.xlsx / .xls / .csv)을 선택합니다."),
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createTextVNode("통장마다 파일을 고른 뒤 "),
                      _createElementVNode("strong", null, "다음"),
                      _createTextVNode("으로 헤더·적요 컬럼을 확인합니다.")
                    ]),
                    _createElementVNode("li", null, "날짜·입금·출금(또는 금액) 컬럼은 가능한 범위에서 자동으로 잡습니다."),
                    _createElementVNode("li", null, [
                      _createTextVNode("업로드 후 계정은 "),
                      _createElementVNode("strong", null, "통장내역"),
                      _createTextVNode(" 화면에서 지정합니다.")
                    ])
                  ])
                ])
              ], -1)),
              _cache[218] || (_cache[218] = _createElementVNode("div", { class: "help-section" }, [
                _createElementVNode("div", { class: "section-title" }, [
                  _createElementVNode("span", { class: "step-badge" }, "2"),
                  _createElementVNode("h4", null, "직접 입력")
                ]),
                _createElementVNode("div", { class: "section-body" }, [
                  _createElementVNode("p", null, "한 건씩 수입/지출·통장·일자·금액·적요를 입력해 저장합니다."),
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, "지출이면 상대계정(선택)을 넣을 수 있습니다."),
                    _createElementVNode("li", null, "같은 날 기존 건이 있으면 삽입 위치를 고를 수 있습니다.")
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_263, [
                _createElementVNode("div", _hoisted_264, [
                  _createVNode(_component_v_icon, {
                    size: "18",
                    color: "#6366f1"
                  }, {
                    default: _withCtx(() => [...(_cache[214] || (_cache[214] = [
                      _createTextVNode("mdi-information-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[215] || (_cache[215] = _createElementVNode("h4", null, "참고", -1))
                ]),
                _cache[216] || (_cache[216] = _createElementVNode("div", { class: "section-body" }, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, "같은 파일을 다시 올려도 이미 등록된 행은 건너뛸 수 있습니다."),
                    _createElementVNode("li", null, "마감된 통장에는 업로드할 수 없습니다.")
                  ])
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_265, [
              _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                onClick: _cache[53] || (_cache[53] = ($event: any) => (showHelpDialog.value = false))
              }, " 확인 ")
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_snackbar, {
        modelValue: showSaveSnackbar.value,
        "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((showSaveSnackbar).value = $event)),
        timeout: 2000,
        color: "#10b981",
        location: "top"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_266, [
            _createVNode(_component_v_icon, {
              size: "18",
              class: "mr-2"
            }, {
              default: _withCtx(() => [...(_cache[219] || (_cache[219] = [
                _createTextVNode("mdi-check-circle", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(saveSnackbarMessage.value), 1)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue", "max-width"]))
}
}

})